/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-09 16:41:54
 * @LastEditTime: 2019-12-19 10:53:49
 * @LastEditTime: 2019-09-09 11:43:43
 * @LastEditors: Please set LastEditors
 */

export default {
  v5: {
    select_files_to_upload: 'Select files to upload',
    my_video_shorts: 'МОИ ВИДЕО SHORTS',
    see_more: 'СМОТРЕТЬ БОЛЬШЕ',
    no_shorts_found: 'Shorts не найдены',
    shorts: 'Shorts',
    general_information: 'Общая информация',
    gamification: 'Геймификация',
    click_to_select_files: 'Нажмите, чтобы выбрать файлы',
    selected_files: 'Выбранные файлы',
    uploaded: 'Загружено',
    failed: 'Не удалось',
    system_will_automatically_analyze_and_select_the_most_relevant:
      'Система автоматически проанализирует и выберет наиболее релевантные документы из библиотеки вашей организации на основе требований к содержанию.',
    select_from_library: ' Выбрать из библиотеки',
    search_document: 'Поиск документа...',
    selected: 'Выбрано',
    loading_documents: 'Загрузка документов...',
    review_generated_content: 'Проверка сгенерированного контента',
    confirm_and_replace_content: 'Подтвердить и заменить контент',
    the_generate_content_will_replace:
      'Сгенерированный контент заменит существующий текст на выбранных страницах. Если вы не хотите применять эти изменения, вы можете вернуться на предыдущий шаг.',
    pages_to_be_updated: 'Страницы для обновления',
    generated_revisions: 'Сгенерированные исправления',
    lesson_preview: 'Предпросмотр урока',
    create_new_folder: 'Создать новую папку',
    rename_item: 'Переименовать элемент',
    enter_folder_name: 'Введите имя папки:',
    enter_new_name: 'Введите новое имя:',
    folder_name: 'Имя папки:',
    new_name: 'Новое имя',
    move_items: 'Переместить элементы',
    copy_items: 'Скопировать элементы',
    move_here: 'Переместить сюда',
    copy_here: 'Скопировать сюда',
    select_destination_library_and_folder:
      'Выберите целевую библиотеку и папку:',
    items_selected: 'Выбранные элементы',
    version: 'Версия',
    modified_by: 'Изменено',
    size: 'Размер',
    restore: 'Восстановить',
    are_you_sure_you_want_to_restore_this_version:
      'Вы уверены, что хотите восстановить эту версию?',
    this_will_replce_the_current_version_with_the_selected_one:
      'Это заменит текущую версию на выбранную.',
    restore_this_version: 'Восстановить эту версию',
    restore_not_available: 'Восстановление недоступно',
    version_history: 'История версий:',
    by_making_items_public:
      'Сделав элементы публичными, они будут видны всем. Пожалуйста, ознакомьтесь с условиями перед продолжением.',
    the_selected_items_will_be_copied:
      'Выбранные элементы будут скопированы в вашу публичную библиотеку и будут видны всем.',
    the_selected_items_will_be_copied_to_org:
      'Выбранные элементы будут скопированы в библиотеку вашей организации и будут видны всем членам организации.',
    the_selected_items_will_be_copied_to_your_private:
      'Выбранные элементы будут скопированы в вашу личную библиотеку и будут видны только вам.',
    loading_organization: 'Загрузка пользователей организации...',
    click_download_to_view: 'Нажмите «Скачать», чтобы просмотреть',
    archive_file: 'Архивный файл',
    no_preview_available: 'Предварительный просмотр недоступен',
    audit_report: 'Отчет аудита',
    audit_type: 'Тип действия',
    i_agree_to_the_terms_and_conditions:
      'Я согласен с условиями и положениями.',
    this_file_is_indexed_for_ai: 'Этот файл индексирован для ИИ.',
    file_is_not_indexed_for_ai: 'Файл не индексирован для ИИ.',
    no_users_found: 'Пользователи не найдены',
    no_users_available: 'Нет доступных пользователей',
    add_people: 'Добавить людей',
    people: 'Люди',
    access_type: 'Тип доступа',
    no_group_found: 'Группы не найдены',
    add_group: 'Добавить группы',
    groups: 'Группы',
    users_top: 'пользователь(и)',
    confirm_delete: 'Подтвердить удаление',
    do_you_want_remove: 'Вы уверены, что хотите удалить',
    form_this_documents_permissions: 'из разрешений этого документа?',
    no_users_found_in_this_group: 'Пользователи в этой группе не найдены',
    add_selected_users: 'Добавить выбранных пользователей',
    choose_users_from_the_list: 'Выберите пользователей из списка',
    selected_users: 'Выбранные пользователи',
    archived: 'Архивировано',
    request_approval: 'Запросить одобрение',
    document_in_review: 'Документ на проверке',
    approve: 'Одобрить',
    reject: 'Отклонить',
    comment: 'Комментарий:',
    enter_your_commit: 'Введите ваш комментарий...',
    confirm_cancel: 'Подтвердить отмену',
    upload_3d_zip: 'Загрузить 3D ZIP',
    delete_items: 'Удалить элементы',
    video_upload_request: 'Запрос на загрузку видео',
    reject_video: 'Отклонить видео',
    enter_rejection_reason: 'Введите причину отклонения...',
    please_provide_a_reason_for_reejection_this_video:
      'Пожалуйста, укажите причину отклонения этого видео:',
    generate_trivia_with_ai: 'Создать викторину с ИИ',
    select_category: 'Выберите категорию:',
    number_of_question: 'Количество вопросов',
    generated_questions: 'Сгенерированные вопросы',
    this_will_clear_all_generate_question:
      'Это удалит все сгенерированные вопросы. Продолжить?',
    sure_delete: 'Вы уверены, что хотите удалить?',
    delete_this_question: 'Вы уверены, что хотите удалить этот вопрос?',
    loading_quiz: 'Загрузка викторины...',
    creteing_file: 'Создание файла',
    opening_desktop_app: 'Открытие настольного приложения',
    this_folder_is_empty: 'Эта папка пуста',
    select_a_competition: 'Выберите соревнование...',
    activity_badges: 'Значки активности',
    awarded_every_badges:
      'Вручается каждые 4, 8, 16, 32, 64, 128, 256, 512 входов',
    learning_badges: 'Значки обучения',
    awarded_every_courses:
      'Вручается каждые 1, 4, 8, 16, 32, 64, 128 завершенных курсов',
    test_badges: 'Тестовые значки',
    awarded_every_passes_tests:
      'Вручается каждые 2, 4, 8, 16, 32, 64, 128, 256 сданных тестов',
    assignment_badges: 'Значки заданий',
    awarded_every_passed_assignments:
      'Вручается каждые 1, 2, 4, 8, 16, 32, 64, 128 выполненных заданий',
    perfectionism_badges: 'Значки перфекционизма',
    awarded_every_assignments_with_scrore:
      'Вручается каждые 1, 2, 4, 8, 16, 32, 64, 128 тестов или заданий с оценкой 90%+',
    communication_badges: 'Значки коммуникации',
    awarded_every_topics_or_comments:
      'Вручается каждые 2, 4, 8, 16, 32, 64, 128, 256 тем или комментариев',
    certification_badges: 'Значки сертификации',
    awarded_every_certificates:
      'Вручается каждые 1, 2, 4, 8, 16, 32, 64, 128 сертификатов',
    level_name: 'Название уровня',
    delete_competition: 'Удалить конкурс',
    this_week: 'На этой неделе',
    this_year: 'В этом году',
    make_organization: 'Сделать организацию',
    no_results_found: 'Результаты не найдены для',
    no_items_available: 'Нет доступных элементов',
    help_video: 'Помощь видео',
    select_a_video_from_the_list:
      'Выберите видео из списка, чтобы начать обучение'
  },
  v4: {
    upload_another_file: 'Upload another file',
    all_files_uploaded: 'All files uploaded',
    upload_and_submit: 'Upload & Submit',
    drop_files: 'Перетащите файл и выберите, куда загрузить.',
    duplicate_lessoon: 'Урок уже добавлен в курс',
    skill_rule_title: 'Пожалуйста, введите название пути навыков',
    imageCreatorTitle: 'Создатель изображений',
    isTranslated: 'Переведено',
    translationCourseDesc:
      'Перевод курса может занять несколько минут. Спасибо за терпение!',
    translateCourseTip:
      'Создайте переведённый курс, который можно изменять независимо от оригинала, включая все уроки и страницы.',
    translateModalBtn: 'Перевести',
    translationSuccess: 'Курс "<0/>" был успешно переведён!',
    translatingCourse: 'Перевод курса...',
    translateModalTitle: 'Перевести курс',
    translateSelectLang: 'Выберите язык',
    fileDeleteconfirm:
      'Вы уверены, что хотите удалить этот файл? Это действие нельзя отменить.',
    fileDeleteMessage: 'Файл успешно удалён.',
    fileDeleteFailedMessage: 'Ошибка при удалении файла!',
    fileDelete: 'Удалить этот файл.',
    certificate_save_btn: 'Добавить сертификат в ',
    maze_path_info: 'Для графа нет доступных путей!',
    file_size_mb: 'Размер файла должен быть меньше 25 МБ!',
    reports: {
      products: 'Продукты',
      users: 'Пользователи',
      ph_username: 'Поиск пользователя по имени',
      ph_id: 'Поиск пользователя по ID',
      ph_email: 'Поиск пользователя по email'
    },
    select_upload_section_id: 'Файл раздела обязателен',
    tags_all: 'Все',
    delete_file_confirm: 'Вы уверены, что хотите удалить этот файл?',
    delete_file_title: 'Удалить файл',
    tooltip_publish: 'Опубликовать курс в выбранной опции',
    tooltip_save: 'Сохранить курс с текущими изменениями',
    tooltip_next: 'Перейти к следующей настройке курса',
    tooltip_finish: 'Завершить и сохранить текущие изменения',
    stories_modal: {
      title_upload: 'Загрузить истории',
      title_update: 'Обновить истории',
      title_audio: 'Аудиофайл истории',
      btn_upload: 'Загрузить',
      btn_update: 'Обновить',
      btn_close: 'Закрыть',
      btn_cancel: 'Отмена',
      lbl_cover: 'Обложка истории',
      rule_cover: 'Пожалуйста, загрузите обложку аудиоистории!',
      lbl_title: 'Название аудиоистории',
      rule_title: 'Пожалуйста, введите название аудиоистории!',
      lbl_description: 'Описание аудиоистории',
      rule_description: 'Пожалуйста, введите описание аудиоистории!',
      lbl_file: 'Загрузить аудиофайл истории',
      rule_file: 'Пожалуйста, загрузите аудиофайл истории!',
      rule_file_type: 'Пожалуйста, загрузите допустимый аудиофайл истории!',
      lbl_select_file: 'Выбрать аудиофайл истории',
      msg_valid_file: 'Пожалуйста, выберите допустимый аудиофайл истории!',
      msg_success: 'Аудиофайл истории успешно загружен',
      msg_failed: 'Не удалось назначить медиафайл!',
      msg_error: 'Ошибка при загрузке файла!'
    },
    audio_modal: {
      title_upload: 'Загрузить',
      title_update: 'Обновить',
      title_audio: 'Аудиофайл',
      btn_upload: 'Загрузить',
      btn_update: 'Обновить',
      btn_close: 'Закрыть',
      btn_cancel: 'Отмена',
      lbl_cover: 'Обложка аудио',
      rule_cover: 'Пожалуйста, загрузите обложку!',
      lbl_title: 'Название аудио',
      rule_title: 'Пожалуйста, введите название аудио!',
      lbl_description: 'Описание аудио',
      rule_description: 'Пожалуйста, введите описание аудио!',
      lbl_file: 'Загрузить аудиофайл',
      rule_file: 'Пожалуйста, загрузите аудиофайл!',
      rule_file_type: 'Пожалуйста, загрузите допустимый аудиофайл!',
      lbl_select_file: 'Выбрать аудиофайл',
      msg_valid_file: 'Пожалуйста, выберите допустимый аудиофайл!',
      msg_success: 'Аудиофайл успешно загружен',
      msg_failed: 'Не удалось назначить медиафайл!',
      msg_error: 'Ошибка при загрузке файла!'
    },
    info_episode: 'Обложка для эпизода.',
    btn_delete_episode: 'Удалить этот эпизод подкаста.',
    btn_edit_marketplace: 'Редактировать детали маркетплейса.',
    btn_save_marketplace: 'Сохранить текущие изменения.',
    btn_ai_podcast: 'Создать подкаст с ИИ.',
    btn_upload_podcast: 'Загрузить свой аудиоэпизод подкаста.',
    attach_file:
      'Загрузите файлы, чтобы поделиться дополнительным контентом с вашей аудиторией',
    fileDownload: 'Скачать этот файл.',
    singleEpishode: 'Эпизод',
    podcast_music: 'подкасты, музыка и истории',
    publishHeader: 'Публикация подкастов, музыки и историй',
    editHeader: 'Редактирование подкастов, музыки и историй',
    createHeader: 'Создание подкастов, музыки и историй',
    marketplaceHeader: 'Детали маркетплейса подкастов, музыки и историй',
    message_marketplace: 'Пожалуйста, заполните форму маркетплейса!',
    create_podcast_live: 'Прямой подкаст и музыка',
    create_podcast_custom: 'Пользовательский подкаст и музыка',
    create_podcast_stories: 'История',
    ai_Assisted_podcast_reation: 'Подкаст и музыка с ИИ',
    publishTitle:
      'Опубликовать подкасты, музыку и истории для публичного просмотра.',
    customButton: 'Создать пользовательский',
    customTitle: 'Сохраняет изменения, внесённые в подкаст.',
    updateButton: 'Обновить',
    createButton: 'Создать',
    createNewButton: 'Создать новый',
    updateTitle: 'Обновить текущие данные подкаста, музыки и историй.',
    createTitle: 'Создать новый подкаст, музыку и истории',
    createNewTitle:
      'Будет создан новый подкаст, музыка и истории на основе текущих данных.',
    podcastTitle: 'Список эпизодов',
    podcastStoryTitle: 'Список эпизодов историй',
    podcastToolTipTitle: 'Список эпизодов подкаста',
    uploadAudio: 'Загрузить аудио',
    aiAudio: 'ИИ аудио',
    emptyPodcast: 'Ещё нет записей подкастов, музыки или историй.',
    emptyStoriesPodcast: 'Истории пока не добавлены.',
    emptyCreatePodcast: 'Пожалуйста, создайте подкаст, чтобы добавить аудио.',
    playPodcast: 'Воспроизвести выбранный подкаст, музыку или историю.',
    pausePodcast: 'Пауза выбранного подкаста, музыки или истории.',
    selectPodcast: 'Выбрать этот подкаст, музыку или историю.',
    downloadPodcast: 'Скачать это аудио.',
    uploadAudioFile: 'Загрузить новый аудиофайл и заменить текущий.',
    deleteConfirm: 'Вы уверены, что хотите удалить этот аудиофайл?',
    roomName: 'Название подкаста',
    addGuestTitle: 'ДОБАВИТЬ ГОСТЯ',
    showTime: 'Время показа',
    startTime: 'Время начала',
    endTime: 'Время окончания',
    erorMsgImg: 'Пожалуйста, выберите допустимое изображение.',
    failedMsgImg: 'Не удалось загрузить изображение. Попробуйте ещё раз!',
    failedMsgUpload: 'Ошибка загрузки обложки!',
    btnCoverUpload: 'Загрузить обложку',
    is_private: 'Приватный',
    to_attach: 'Прикрепить файл',
    file_attached: 'Файл(ы) прикреплён(ы)',
    main_event: 'Главное событие',
    event: 'События',
    upload_pdf: 'Загрузить PDF',
    portrait: 'Портрет',
    landscape: 'Альбом',
    import_from_library: 'Импортировать текст из медиатеки',
    question_answer_ai: 'Вопрос/Ответ ИИ',
    take_maze: 'ПРОЙТИ MetaMaze',
    training: 'Обучение',
    select_transcribe_locale: 'Выберите язык для транскрипции',
    transcribe_limit: 'Введите количество минут для транскрипции',
    not_complete: 'Информация о Marketplace не завершена',
    complete: 'Информация о Marketplace завершена',
    not_admin: 'Требуются права администратора для публикации в Marketplace',
    no_course:
      'Введите заголовок и выберите изображение для активации Marketplace',
    scorm_not_complete:
      'Введите заголовок и выберите изображение для загрузки SCORM-файла',
    not_found_maze: 'MetaMaze не найден',
    email_require: 'Требуются адреса электронной почты',
    poll_required: 'Необходимы данные опроса',
    alert: 'Оповещение!',
    warning: 'Предупреждение!',
    ok: 'Ок',
    cancel: 'Отмена',
    done: 'Готово',
    insert: 'Вставить',
    private: 'Приватный',
    public: 'Публичный',
    no_connection: 'Интернет-соединение потеряно',
    switch: 'Переключить',
    share_screen: 'Поделиться экраном',
    stop_share_screen: 'Остановить показ экрана',
    share_screen_with_camera: 'Поделиться экраном с камерой',
    stop_share_screen_with_camera: 'Остановить показ экрана с камерой',
    camera_on: 'Камера включена',
    camera_off: 'Камера выключена',
    mic_on: 'Включить микрофон',
    mic_off: 'Выключить микрофон',
    fullscreen: 'Полноэкранный режим',
    live_now: 'В эфире',
    schedule_on: 'Запланировано на',
    organisations: 'Организации',
    org_groups: 'Группы организаций',
    specific_user: 'Конкретный пользователь',
    gif: 'GIF',
    unavailable: 'Недоступно',
    yes: 'Да',
    no: 'Нет',
    event_duration_message: 'Максимум 300 минут (5 часов)',
    send_email: 'Отправить уведомление по электронной почте',
    admin_only: 'Только для администратора',
    join: 'Присоединиться',
    leave: 'Покинуть',
    share: 'Поделиться',
    share_text:
      'Введите адрес электронной почты, чтобы поделиться этим файлом.',
    share_text_title: 'Поделиться PDF',
    share_text_title_txt: 'Поделиться текстом',
    select_users: 'Выбрать пользователей',
    delete: 'Удалить',
    attachment_event: 'Вложения к событию:',
    transcribe_limit: 'Минуты транскрипции',
    monthly_transcribe: 'Месячный лимит транскрипции:',
    enable_ai: 'Включить ИИ:',
    enable_maze: 'Включить MetaMaze:',
    media_service: 'Медиа-сервис',
    allow_others: 'Разрешить другим редактировать',
    join_breakout_room: 'Войти в сессионный зал',
    bio: 'Биография',
    linkedin: 'LinkedIn',
    select_org_report: 'Найдите и выберите организацию для генерации отчета.',
    org_image_not_found: 'Изображение не найдено',
    insert_text: 'Вставить текст',
    insert_question_answer: 'Вопрос/Ответ ИИ',
    modal_title2: 'Галерея текстов',
    my_text_library: 'Моя библиотека текстов',
    ai: 'ИИ',
    public_text_library: 'Публичная библиотека текстов',
    organization_text_library: 'Библиотека текстов организации',
    no_transcribed_text: 'Транскрибированных текстов не найдено',
    public_text_not_found: 'Публичные транскрибированные тексты не найдены',
    org_text_not_found: 'Транскрибированные тексты организации не найдены',
    org_video_not_found: 'Видео не найдено',
    canva: 'Сделайте это в Canva',
    canva_open: 'Нажмите здесь, чтобы открыть редактор Canva.',
    pdf: 'PDF',
    txt: 'ТЕКСТ',
    human: 'Премиум',
    shared_file: 'Файл успешно отправлен.',
    error_shared_file: 'Ошибка при отправке файла. Попробуйте еще раз.',
    publish: 'Опубликовать',
    maze_scenes: 'Сцены MetaMaze',
    pexel_images: 'Изображения Pexel',
    group: 'Группа',
    group_name: 'Название группы',
    select_group: 'Выбрать группу',
    search_maze: 'Поиск MetaMaze',
    hosts: 'Хосты',
    avg_score: 'Процент правильных ответов',
    maze_report: 'Отчет по Maze',
    maze_view: 'Просмотр Maze',
    title_maze: 'MetaMaze',
    author: 'Автор',
    match: 'Совпадение пути',
    preview_mazeTitle: 'Заголовок: ',
    other: 'Другое',
    total: 'ВСЕГО',
    report_course: 'КУРС',
    report_courses: 'КУРСЫ',
    report_event: 'СОБЫТИЕ',
    report_events: 'СОБЫТИЯ',
    report_maze: 'MAZE',
    report_personalize_learning: 'ПЕРСОНАЛИЗИРОВАННОЕ ОБУЧЕНИЕ',
    report_live_assessment: 'ОЦЕНКА В РЕАЛЬНОМ ВРЕМЕНИ',
    report_live_assessments: 'ОЦЕНКИ В РЕАЛЬНОМ ВРЕМЕНИ',
    report_skill_journey: 'ПУТЬ НАВЫКОВ',
    skill_journey: 'Путь навыков',
    skill_journeys: 'Пути навыков',
    date: 'ДАТА: ',
    search_people: 'Поиск людей',
    passed: 'ПРОЙДЕНО',
    failed: 'НЕ ПРОЙДЕНО',
    item: 'ЭЛЕМЕНТ',
    type: 'ТИП',
    minimum_pass_score: 'МИНИМАЛЬНЫЙ БАЛЛ ДЛЯ ПРОХОЖДЕНИЯ',
    resources_count: 'КОЛИЧЕСТВО РЕСУРСОВ',
    back: 'НАЗАД',
    resources: 'РЕСУРСЫ',
    time_spent: 'ПРОВЕДЕННОЕ ВРЕМЯ (МИН)',
    detail: 'ПОДРОБНОСТИ',
    watched_time_mins: 'ВРЕМЯ ПРОСМОТРА (МИН)',
    personalize_learning: 'Персонализированное обучение',
    result: 'Результат',
    assessment_title: 'Заголовок',
    marketPlace_graph: 'График Marketplace',
    attachments: 'Дополнительные вложения',
    new_scorm_course: 'Загрузить новый SCORM-курс',
    upload_scorm_course: 'Загрузить SCORM-курс',
    new_maze: 'Создать новый MetaMaze',
    new_skill_journey: 'Создать маршрут навыков',
    tags_scorm: 'SCORM',
    tags_skillJourney: 'Маршрут навыков',
    new_discussion_room: 'Создать новый подкаст',
    title: 'Что вы хотите сделать сегодня?',
    build_course: 'Создать мой курс',
    live_broadcast: 'Прямая трансляция',
    invite_users: 'Пригласить пользователей в мою организацию',
    build_voice_over: 'Создать мой озвучивание',
    view_reports: 'Просмотреть отчёты',
    upload_media: 'Загрузить мои медиа или работу и поделиться ими',
    main_menu: 'Главное меню',
    get_started: 'НАЧАТЬ',
    search_group: 'Поиск группы организации',
    ai_course: 'Курс ИИ',
    search_user: 'Поиск по названию компании',
    no_maze: 'В настоящее время нет MetaMaze.',
    conference_event_title: 'Конференции',
    conference_event_subTitle: 'Завершённые конференции',
    conference_event: 'В настоящее время нет мероприятий конференции.',
    no_skill: 'В настоящее время нет маршрутов навыков.',
    no_podcast: 'В настоящее время нет подкастов.',
    maze_channel: 'MetaMaze',
    past_live_assessment: 'Прошедшие оценки в реальном времени',
    no_live_assessment: 'В настоящее время нет оценок в реальном времени.',
    enrolled_courses: 'Курсы',
    my_video_channel: 'Мои видеоканалы',
    enrolled_liveEvents: 'Мероприятия в реальном времени',
    sharebot: 'Sharebot',
    selected_language: 'Выбранный язык',
    shareSphere_game: 'Игра ShareSphere',
    maze: 'MetaMaze',
    skill: 'Маршрут навыков',
    channel: 'Канал',
    order: 'Заказ',
    is_record: 'Запись',
    no_maze_found: 'MetaMaze не найден.',
    maze_self_limit_reached: 'Достигнут лимит самопроверки MetaMaze.',
    metamaze_two_times: 'Вы уже проходили этот MetaMaze 2 раза.',
    metamaze_two_times_no_result:
      'Вы уже проходили этот MetaMaze 2 раза. Результат не будет сохранён при прохождении более двух раз.',
    scorm_zip: 'SCORM ZIP',
    pass_score: 'Минимальный проходной балл',
    organization: 'Пожалуйста, выберите организацию',
    pass_score_mark: 'Введите значение от 1 до 100',
    maze_cloning_success: 'MetaMaze "<0/>" успешно клонирован!',
    create_certificate: 'Создать сертификат',
    create_badge: 'Создать значок',
    certificate_added: 'Сертификат добавлен.',
    badge_added: 'Значок добавлен.',
    certificate_warning:
      'После публикации сертификат/значок нельзя будет отредактировать!',
    created_course_plan:
      'Отредактируйте и опубликуйте свой курс и запланируйте мероприятия в реальном времени',
    market_place_space: 'Маркетплейс',
    select_course_language: 'Выбрать язык (необязательно)',
    select_language: 'Выбрать язык',
    file_upload: 'Загрузка файла',
    text: 'Введите текст здесь…',
    attempts_count: 'Количество попыток, доступных пользователю',
    no_of_people_placeholder: 'Количество людей',
    back_to_maze: 'Назад к сценарию MetaMaze',
    edit_maze: 'Редактировать Maze',
    wait: 'Пожалуйста, подождите...',
    retry: 'Повторить',
    publish_scorm_course: 'Опубликовать ваш SCORM-курс',
    publish_maze: 'Опубликовать ваш MetaMaze',
    import: 'Импортировать элементы',
    answer_correct: 'Выберите правильный ответ',
    author_name: `Пожалуйста, введите имя автора`,
    select_category: 'Пожалуйста, выберите категорию',
    course_outline: 'Пожалуйста, введите план курса',
    course_obj: 'Пожалуйста, введите цели курса',
    course_description: 'Пожалуйста, введите описание курса',
    maze_outline: 'Пожалуйста, введите план лабиринта',
    maze_obj: 'Пожалуйста, введите цели лабиринта',
    maze_description: 'Пожалуйста, введите описание лабиринта',
    lessons: 'Пожалуйста, введите количество уроков',
    user_email_require: `Требуется электронная почта пользователя`,
    team_size: `Требуется указать размер команды`,
    enter_price: 'Пожалуйста, введите цену (от 5 и выше)',
    input_title_maze: 'Пожалуйста, введите название лабиринта',
    trainer_bio: 'Пожалуйста, введите биографию тренера',
    trainer_linkedin: 'Пожалуйста, введите ссылку на LinkedIn тренера',
    error_video: 'Пожалуйста, введите количество видео',
    input_video_link: 'Пожалуйста, введите ссылку на видео',
    number_of_video: 'количество видео',
    number_of_lessions: 'количество уроков',
    no_of_people_in_conference: 'Сколько человек на конференции?',
    transcribe_settings: 'Настройки транскрипции',
    transcribe: 'Транскрибировать',
    cloning_maze: 'Клонирование MetaMaze...',
    id_number: 'Номер ID',
    timezone: 'Часовой пояс',
    edit_maze: 'Редактировать',
    delete_maze: 'Удалить',
    view_maze: 'Просмотр',
    create_metamaze: 'Создать MetaMaze',
    metamaze_scenario: 'Сценарий MetaMaze',
    publish_metamaze: 'Настройка публикации',
    search_result: 'Результаты поиска:',
    search_for: 'Поиск по',
    search_no_result: '- Результаты не найдены!',
    channel_no_available: 'Канал недоступен!',
    this_card: 'Это карточка',
    course_no_available: 'Курсы недоступны!',
    exit_fullscreen: 'Выйти из полноэкранного режима',
    bg_image: 'Фоновое изображение',
    introduction: 'Введение',
    summary: 'Резюме',
    generate_introduction: 'Сгенерировать введение',
    generate_summary: 'Сгенерировать резюме',
    bullet_points: 'Маркированные пункты',
    title_simulation: 'Пожалуйста, введите название симуляции',
    view_generated_images: 'Просмотр сгенерированных изображений',
    image_transparency: 'Прозрачность изображения',
    template_bg_color: 'Цвет фона шаблона',
    select_template_layout: 'Выберите макет шаблона',
    reload_template: '(Перезагрузить шаблоны)',
    are_you_sure_want_close: 'Вы уверены, что хотите закрыть?',
    all_your_changes_will_be_lost: 'Все ваши изменения будут потеряны.',
    please_checked_before_generated_video:
      'Пожалуйста, убедитесь, что все условия отмечены перед созданием видео.',
    voice_must_be_selected: 'Необходимо выбрать голос',
    avatar_must_be_selected: 'Необходимо выбрать аватар',
    maximum_five_slides_try_again:
      'Ошибка при извлечении изображений. Убедитесь, что в файле не более 5 слайдов и у каждого есть заметки. Повторите попытку!',
    back_to_upload: 'Назад к загрузке',
    uploading_file_to_server: 'Загрузка файла на сервер',
    extracting_images_from_your_file: 'Извлечение изображений из файла',
    upload_your_ppt_or_drag:
      'Загрузите презентацию (.PPTX) или перетащите файл сюда.',
    maximum_five_slides_error:
      'Убедитесь, что в вашем файле PowerPoint не более 5 слайдов и у каждого есть заметки. В противном случае возникнет ошибка.',
    number_of_questions_generated: 'Количество создаваемых вопросов',
    quiz_page_this_cannot_be_done:
      'Вы уверены, что хотите добавить викторину на эту страницу? Это действие нельзя отменить.',
    confirm_selection: 'Подтвердить выбор',
    select_quiz_page: 'Выберите страницу викторины',
    lesson_do_you_want_add_this_quiz:
      'В какую часть урока вы хотите добавить эту викторину?',
    beginning_of_lesson: 'В начале урока',
    end_of_lesson: 'В конце урока',
    currently_active_page: 'Текущая активная страница',
    finish: 'Завершить',
    upload_selection_file: 'Загрузить файл секции',
    general_quiz: 'Общая викторина',
    manage_sequence: 'Управление последовательностью',
    save_sequence: 'Сохранить последовательность',
    new: 'Новый',
    in_progress: 'В процессе',
    recommended_course: 'Рекомендуемый курс',
    up_coming: 'Скоро',
    past_live: 'Прошедшие трансляции',
    input_your_channel_name: 'Пожалуйста, введите название вашего канала!',
    organization_place: 'Маркетплейс организации',
    marketplace_report: 'Отчет маркетплейса',
    story_writing: 'Написание истории',
    Ai_quiz: 'Викторина ИИ',
    generate_quiz: 'Сгенерировать викторину',
    create_story: 'Создать историю',
    change_layout_page: 'Вы собираетесь изменить макет этой страницы.',
    change_layout_message:
      'Обратите внимание: будут сохранены только текст, изображения, фон и логотип. Все остальные элементы будут удалены.',
    reviews: 'Отзывы',
    tab_attachments: 'Вложения',
    zoom_in: 'Увеличить',
    zoom_out: 'Уменьшить',
    zoom_reset: 'Сбросить масштаб',
    no_attachment: 'Нет вложений.',
    select_upload_simulation: 'Пожалуйста, выберите/загрузите симуляцию.',
    quiz_updated_successfully: 'Викторина успешно обновлена!',
    quizes: 'Викторины',
    trivia: 'Тривия',
    closing: 'Закрытие...',
    products: 'Продукты',
    ask_questions: 'Задайте вопрос здесь...',
    course_information: 'Информация о курсе',
    course_assistance: 'Помощь создателю курса',
    go_back: 'Вернуться',
    ai_generate_content_progress: 'Прогресс генерации контента',
    view_generate_content: 'Просмотреть созданный контент',
    generate_error: 'Ошибка создания!',
    confirm_creating_course:
      'Вы уверены, что хотите создать курс с этим содержанием?',
    generate_content_automatically:
      'Это автоматически добавит весь сгенерированный контент в виде уроков и страниц в ваш курс.',
    quiz_created_successfully: 'Викторина успешно создана!',
    create_quiz: 'Создать викторину',
    quiz_setting: 'Настройки викторины',
    please_fill_quiz_setting:
      '* Пожалуйста, заполните все поля в настройках викторины',
    question_list: 'Список вопросов',
    add_quiz_to_page: 'Добавить викторину на страницу',
    form_create_question: 'Форма создания вопроса',
    user_information_updated: 'Информация пользователя обновлена!',
    your_stripe_activete_to_continue:
      'Ваш аккаунт Stripe не активирован. Пожалуйста, подключите или активируйте его для продолжения.',
    connect_tripe: 'Подключить Stripe',
    certificate_sent_sucessfully:
      'Сертификат успешно отправлен на вашу электронную почту.',
    error_try_again: 'Ошибка. Попробуйте снова!',
    error_delete_channel: 'Ошибка при удалении канала.',
    error_update_sub: 'Ошибка при обновлении подписки.',
    end_time_cannot_start: 'Время окончания не может быть раньше начала.',
    start_date_time_interval: 'Необходимы дата и время начала!',
    podcast_updated_successful: 'Подкаст успешно обновлён.',
    podcast_created_successful: 'Подкаст успешно создан.',
    podcast_published_successful: 'Подкаст успешно опубликован.',
    podcast_cover_updated: 'Обложка подкаста обновлена.',
    new_podcast_details:
      'На основе текущего подкаста и новых данных будет создан новый подкаст.',
    current_update_podcast: 'Обновление текущего подкаста, музыки и историй.',
    create_new_podcast: 'Создать новый подкаст',
    publish_podcast_public_view:
      'Опубликовать подкаст для публичного просмотра.',
    only_allowed_twenty_five_email: 'Разрешено только 25 email-адресов.',
    only_allowed_five_email: 'Разрешено только 5 email-адресов.',
    cover_is_required: 'Обложка обязательна.',
    topic_is_required: 'Тема обязательна.',
    delete_schedule: 'Удалить расписание',
    make_as_coaching: 'Отметить как доступный коучинг',
    manage_category: 'Управление категорией',
    threshold: 'Порог',
    threshold_popup:
      'Пороговое значение в процентах (%), при достижении которого активируется рекомендация для категории.',
    list_of_catagory: 'Список категорий',
    category_name: 'Название категории',
    category_threshold: 'Порог категории',
    play_game: 'Играть',
    switching_organization: 'Переключение организации...',
    coaching_session: 'Сессия коучинга',
    required_channel_id: 'Требуется ID канала!',
    error_occured_try_again: 'Произошла ошибка. Попробуйте снова!',
    please_complete_marketplace_form:
      'Пожалуйста, заполните форму Marketplace!',
    upload_file_corrupt: 'Загруженный файл повреждён.',
    course_not_published: 'Курс ещё не опубликован!',
    error_request: 'Ошибка запроса. Пожалуйста, попробуйте снова!',
    skill_request: 'Пожалуйста, заполните все обязательные поля!',
    error_occured: 'Произошла ошибка. Попробуйте снова!',
    show_time: 'Показать время',
    start_time: 'Время начала',
    end_time: 'Время окончания',
    room_name: 'Название подкаста',
    add_guest_speaker: 'Добавить гостя-лекторa',
    cover_picture: 'Изображение обложки',
    guest_speaker: 'Гость-лектор',
    see_more: 'Узнать больше',
    see_less: 'Свернуть',
    background: 'Фон',
    icon: 'Иконка',
    icon_size: 'Размер иконки',
    icon_color: 'Цвет иконки',
    only_text: 'Только текст',
    change_bg: 'Изменить фон',
    bg_color: 'Цвет фона',
    font_size: 'Размер шрифта',
    normal: 'Обычный',
    change_color: 'Изменить цвет текста',
    slant_text: 'Наклонённый текст',
    text_radius: 'Радиус текста',
    vertical_align: 'Вертикальное выравнивание',
    horizontal_align: 'Горизонтальное выравнивание',
    change_icon_color: 'Изменить цвет иконки',
    upload_icon: 'Загрузить иконку',
    upload_signature: 'Загрузить подпись',
    add_another_sign: 'Добавить ещё подпись',
    name_badges: 'Имя бейджа',
    should_less_150: 'должно быть 150 символов или меньше',
    your_badge: 'Ваш бейдж',
    do_you_want_delete_badge: 'Вы хотите удалить этот бейдж?',
    do_you_want_delete_cert: 'Вы хотите удалить этот сертификат?',
    upload_logo: 'Загрузить логотип',
    name_of_cert: 'Название сертификата',
    upload_cert: 'Обновить сертификат',
    your_cert: 'Ваш сертификат',
    translate_to: 'Перевести на',
    select_file_attach: 'Выберите файл для прикрепления',
    certificate: 'Сертификат',
    badge: 'Бейдж',
    publish_options: 'Параметры публикации',
    publish_skills_journey: 'Опубликовать путь навыков',
    videos: 'Видео',
    generate_ai_video:
      'Процесс создания видео может занять некоторое время. Вы получите уведомление по электронной почте после завершения.',
    trainer_information: 'Информация о тренере',
    promotional_video_link: 'Ссылка на промо-видео',
    please_select: 'Пожалуйста, выберите',
    image_name: 'Название изображения:',
    image_size: 'Размер изображения:',
    charecters_fifteen_less: '15 символов или меньше',
    leadership: 'Лидерство',
    text_arc: 'Дуга текста',
    vertical: 'Вертикальный',
    horizontal: 'Горизонтальный',
    badge_history: 'История бейджей',
    templates: 'Шаблоны',
    sign: 'Подпись',
    logo: 'Логотип',
    certificate_history: 'История сертификатов',
    please_wait: 'Пожалуйста, подождите...',
    information: 'Информация',
    support_five_thousand_live_event:
      'Поддерживает до 5000 участников мероприятия',
    support_ten_live_event: 'Поддерживает до 10 участников видео-трансляции',
    we_will_back_participant:
      'Мы вернёмся с мероприятием с большим числом участников.',
    course_objectives: 'Цели курса',
    course_outlines: 'Структура курса',
    price_dollor: 'цена (usd)',
    not_completed: 'Не завершено',
    enable_marketplace: 'Активировать Marketplace',
    enable_course_ai: 'Активировать создание курса с ИИ',
    enable_report_to_admin: 'Активировать отчёты для администратора',
    enable_white_label: 'Активировать White Label',
    enable_eleven_labs_for_maze_play: 'Активировать Elevenlabs для Maze Play',
    enable_eleven_labs_for_maze_play_cloned:
      'Активировать клонированный голос Elevenlabs',
    simulation_quiz: 'Симуляционная викторина',
    bg_color_setting: 'Настройка цвета фона',
    color_preview: 'Предпросмотр цвета',
    choose_new_color: 'Выбрать новый цвет',
    remove_color: 'Удалить цвет',
    apply_color: 'Применить цвет',
    elemeent_in_a_sceenario_page:
      'Нельзя добавить другой элемент на страницу сценария. Попробуйте другую страницу или сначала удалите сценарий.',
    no_data_found: 'Данные не найдены.',
    references: 'Ссылки',
    open_file: 'Открыть файл',
    showing_result: 'Отображение результата:',
    fiften_day_free_trail: '15-дневная бесплатная пробная версия',
    your_browser_does_not_support: 'Ваш браузер не поддерживает аудиоэлемент.',
    podcast_desc: 'Описание подкаста',
    input_podcast_desc: 'Пожалуйста, введите описание подкаста',
    podcast_obj: 'Цели подкаста',
    input_podcast_obj: 'Пожалуйста, введите цели подкаста',
    podcast_outline: 'План подкаста',
    input_podcast_outline: 'Пожалуйста, введите план подкаста',
    add_file: 'Добавить файл',
    generate_podcast_audio: 'Сгенерировать аудио подкаста',
    generate_uploaded_file_input_parameter:
      'Генерирует контент на основе загруженных пользователем файлов и заданных параметров.',
    go_backe_generation_state: 'Вернуться к этапу генерации контента.',
    create_ai_powered_podcast:
      'Создать подкаст(ы) с генерацией аудио на базе ИИ.',
    generate_voice_for_all_podcast:
      'Пожалуйста, сгенерируйте голос для всех эпизодов подкаста',
    create_podcast_episode: 'Создать эпизод подкаста',
    voice_name: 'Имя голоса',
    input_custom_name: 'Пожалуйста, введите собственное имя!',
    enter_custom_name: 'Введите собственное имя голоса',
    upload_complete: 'загрузка завершена',
    uploading_in_progress: 'загрузка в процессе...',
    podcast_stream_content: 'Контент потока подкаста',
    upload_podcast_cover: 'Пожалуйста, загрузите обложку подкаста!',
    enter_podcast_name: 'Пожалуйста, введите название подкаста!',
    podcast_topic: 'Тема подкаста',
    enter_podcast_topic: 'Пожалуйста, введите тему подкаста!',
    enter_podcast_desc: 'Пожалуйста, введите описание подкаста!',
    number_of_speaker: 'Количество участников',
    select_the_number_of_speaker: 'Пожалуйста, выберите количество участников!',
    number_of_episode: 'Количество эпизодов',
    input_number_of_episode: 'Пожалуйста, введите количество эпизодов!',
    podcast_length: 'Длительность подкаста',
    select_the_podcast_length: 'Пожалуйста, выберите длительность подкаста!',
    short_podcast: 'Короткий (5–10 мин)',
    medium_podcast: 'Средний (15–18 мин)',
    long_podcast: 'Длинный (18+ мин)',
    name_of_host: 'Имя ведущего',
    enter_host_name: 'Пожалуйста, введите имя ведущего!',
    guest_name: 'Имена гостей',
    enter_guest_name: 'Пожалуйста, введите имя гостя!',
    choose_speaker_tone: 'Выберите тон голоса',
    enter_speaker_tone: 'Пожалуйста, выберите тон подкаста!',
    informal: 'Неформальный',
    formal: 'Формальный',
    serious: 'Серьёзный',
    light_humor: 'Лёгкий юмор',
    casual: 'Обычный',
    select_content_source: 'Выбрать источник контента',
    from_internet: 'Из интернета',
    upload_pdf_internet: 'Загрузить PDF или внутренний документ',
    note: 'Примечание:',
    podcast_content_will_be_automatically_generated:
      'Контент подкаста будет автоматически сгенерирован из проверенных источников в интернете.',
    upload_or_select_file: 'Пожалуйста, загрузите или выберите файл(ы)!',
    podcast_eposode_title: 'Название эпизода подкаста',
    enter_podcast_title: 'Пожалуйста, введите название эпизода!',
    podcast_episode_des: 'Описание эпизода подкаста',
    enter_podcast_episode_des: 'Пожалуйста, введите описание эпизода!',
    voice: 'Голос',
    music: 'Музыка',
    select_music: 'Выбрать музыку',
    play_the_music: 'Воспроизвести музыку',
    stop_the_music: 'Остановить музыку',
    context: 'Контекст',
    generate_audio_content_selected_voice:
      'Сгенерировать аудио на основе выбранных голосов.',
    required_field_before_submitting:
      'Пожалуйста, заполните все обязательные поля перед отправкой.',
    regenerate_voice: 'Сгенерировать голос заново',
    generate_voice: 'Сгенерировать голос',
    your_browser_does_not_suppot: 'Ваш браузер не поддерживает элемент audio.',
    are_sure_leave_podcast: 'Вы уверены, что хотите покинуть подкаст?',
    broadcast_ongoing:
      'Трансляция в процессе. Вы действительно хотите покинуть эту страницу?',
    brodcaster_unavailable: 'Транслятор в данный момент недоступен.',
    setting_calender_for_booking: 'Настройка календаря для бронирования',
    add_calender: 'Добавить календарь',
    waiting_join_host: 'Ожидание подключения ведущего...',
    no_reviews_found: 'Отзывы не найдены.',
    rated_already: 'Вы уже оценили это событие в прямом эфире.',
    downlink_png: 'скачать_png',
    downlink_jpg: 'скачать_jpg',
    donwload_file_format: 'Пожалуйста, выберите формат файла для скачивания.',
    crashed_event:
      'Это событие завершилось сбоем. Необходимо создать новое событие. Извините за неудобства.',
    prompt: 'Подсказка:',
    generated_image: '🚀 Генерация изображения... Пожалуйста, подождите.',
    download_add: 'Скачать всё',
    setting_generator: 'Настройки генератора',
    enter_image_prompt: 'Пожалуйста, введите запрос для изображения',
    image_prompt: 'Введите запрос для изображения',
    negative_prompt: 'Негативная подсказка',
    negative_image_prompt: 'Введите негативную подсказку для изображения',
    number_output: 'Количество результатов',
    enter_number_output: 'Пожалуйста, введите количество результатов',
    image_style: 'Пожалуйста, выберите стиль изображения',
    output_format: 'Формат вывода',
    seeds: 'Семена',
    enter_seeds: 'Пожалуйста, введите количество семян',
    performance_mode: 'Режим производительности',
    quality: 'Качество',
    speed: 'Скорость',
    balanced: 'Сбалансированный',
    guidance_scale: 'Шкала направляющих',
    enter_guidance: 'Пожалуйста, введите шкалу направляющих',
    select_image: 'Пожалуйста, выберите изображение.',
    image_prmt: 'Запрос к изображению',
    generate_image_list_empty: 'Список сгенерированных изображений пуст.',
    knowledge_center_tooltrip_des:
      'Получайте краткие и точные ответы на широкий круг вопросов благодаря ИИ, обученному на разнообразных интернет-данных.',
    contexts: 'Контексты',
    ai_processing_video_sharebot:
      'Обработка видео ИИ займет около 24 часов и отразится в Sharebot.',
    remove_sharebot_video:
      'Если вы хотите убрать упоминание видео в Sharebot, удалите соответствующую транскрипцию вместе с видео.',
    remove_sharebot_video_audio:
      'Удаление транскрипции уберет видео/аудио из Sharebot, но само видео останется в медиатеке/канале.',
    monthly_live_stream:
      'Чтобы изменить лимит ежемесячных трансляций, пожалуйста, свяжитесь с',
    monthly_transcribe_limit:
      'Чтобы изменить лимит ежемесячных транскрипций, пожалуйста, свяжитесь с',
    must_be_one_to_three_hundred: 'Должно быть от 1 до 300 минут.',
    all_field_required: 'Все поля обязательны для заполнения.',
    duration_minute: 'Длительность (макс. 300 минут)',
    gender: 'Пол',
    select_gender: 'Выберите пол',
    accent: 'Акцент',
    select_accent: 'Выберите акцент',
    create_voice: 'Создать голос',
    enter_voice_name: 'Введите имя голоса',
    select_voice_gender: 'Пожалуйста, выберите пол голоса',
    upload_voice: 'Загрузите свой голос',
    upload_voice_mp_three: 'Загрузите свой голос (.mp3)',
    cloned_voice: 'Клонированные голоса',
    voice_type: 'Тип голоса',
    select_voice_type: 'Выберите тип голоса',
    sharelook_stand: 'Стандарт',
    sharelook_premium: 'Премиум',
    sharelook_custum_voice: 'Пользовательский (Клонирование голоса)',
    create_auto_flow: 'Создать автоматический поток',
    how_many_layers: 'Сколько слоёв',
    verify_selection: 'Подтвердите выбор',
    uploaded_successful: 'Успешно загружено',
    upload_failed: 'Ошибка загрузки',
    upload_only_five_mb: 'Загрузить контент (PDF-файлы, максимум 5)',
    docs_from_org_library: 'Использовать документ из библиотеки организации',
    failed_maze_generate:
      'Не удалось сгенерировать лабиринт. Пожалуйста, попробуйте снова.',
    generate_metamaze: 'Генерация MetaMaze...',
    metamaze_being_generated:
      'Ваш MetaMaze генерируется. Вы получите уведомление по электронной почте после завершения процесса.',
    metamaze_generate_successfully: 'MetaMaze успешно сгенерирован!',
    metamaze_with_proceed: 'Теперь вы можете продолжить с MetaMaze.',
    ai_metamaze_generate: 'Генерация MetaMaze с помощью ИИ',
    what_kind_maze_create: 'Какой тип лабиринта вы хотите создать?',
    manual_metamaze_creation: 'Ручное создание MetaMaze',
    manually_maze_customizing_scnario:
      'Создайте лабиринт вручную, настроив сценарий и дерево опций',
    maze_ai_generated: 'Автоматически сгенерировать лабиринт с помощью ИИ',
    unmark_deadend: 'Снять пометку тупика',
    mark_deadend: 'Отметить как тупик',
    select_multiple_image_for_scenario:
      'Вы можете выбрать несколько изображений для сценария.',
    select_your_image: 'Ваши выбранные изображения',
    click_to_preview: 'Нажмите для предварительного просмотра',
    are_you_sure_delete_image:
      'Вы уверены, что хотите удалить это изображение?',
    select_image_from_library: 'Выбрать изображение из медиатеки',
    uploading_video: 'Загрузка видео...',
    tree_node_type: 'Тип узла дерева',
    correct_option_scenario: 'Правильный вариант или сценарий',
    incorrect_option: 'Неправильный вариант',
    option_scenario_without_text: 'Вариант или сценарий без текста',
    dead_end: 'Тупик (Красная рамка)',
    correct_path: 'Правильный путь',
    incorrect_path_not_selected_correct_option_path:
      'Неправильный путь / путь, где не выбран правильный вариант.',
    double_click_on_tree_node:
      'При двойном щелчке по узлу дерева редактор текста автоматически прокрутится к содержимому этого узла.',
    add_scenario: 'Добавить сценарий',
    add_option: 'Добавить вариант',
    an_error_occured: 'Произошла ошибка:',
    download_summary: 'Скачать сводку',
    step_wise_analysis: 'Пошаговый анализ',
    step: 'Шаг',
    upload_csv_file: 'Загрузить CSV-файл',
    download_template_to_import: 'Скачать образец шаблона для импорта',
    please_input_email: 'Пожалуйста, введите email.',
    email_at_least_three_characters:
      'Email должен содержать не менее 3 символов.',
    email_cannot_be_empty: 'Email не может быть пустым.',
    input_email_in_new_line: 'Введите email-адреса (каждый с новой строки)',
    role: 'Роль',
    select_role: 'Пожалуйста, выберите роль',
    select_group: 'Пожалуйста, выберите группу',
    identification_number: 'Идентификационный номер (необязательно)',
    add_identification_number: 'Пожалуйста, добавьте идентификационный номер',
    pie_chart_of_all_categories:
      'Круговая диаграмма всех категорий на основе их использования в Sharelook.',
    total_sharesphere_question_answered_by_users:
      'Общее количество вопросов ShareSphere, на которые ответили пользователи текущей организации, с указанием категорий и результатов (успехов и неудач).',
    voice_style_over_the_text:
      'Где вы можете использовать множество стилей голоса для текста, который вы набираете. Lorem Ipsum — это просто фиктивный текст полиграфической и издательской индустрии.',
    input_your_question: 'Пожалуйста, введите ваш вопрос!',
    make_me_sales_manager:
      'например: Что может сделать меня менеджером по продажам',
    enter_the_number_relevant_document:
      'Введите количество соответствующих документов',
    please_wait_loading_result:
      'Пожалуйста, подождите, загружаются результаты...',
    no_result_found: 'Результаты не найдены. Попробуйте задать другой вопрос',
    browser_doesnot_support_iframes: 'Ваш браузер не поддерживает iframe',
    total_duration: 'Общая продолжительность',
    number_of_messages: 'Количество сообщений',
    search_result: 'Результаты поиска',
    count_result: '(1244 результатов)',
    your_other_interests: 'Ваши другие интересы',
    your_total_score: 'Ваш общий балл',
    add_a_question: '+добавить вопрос',
    travia_question_empty: 'Список вопросов для Travia пуст.',
    video_generation_is_on_queue: 'Генерация вашего видео находится в очереди!',
    checking_video_status: 'Проверка статуса видео...',
    total_quizzes: 'Всего викторин',
    number_of_votes: 'Количество голосов',
    total_events: 'Всего событий',
    number_of_rates: 'Количество оценок',
    number_of_likes: 'Количество лайков',
    all_courses: 'Все курсы',
    total_questions: 'Всего вопросов',
    no_skill_journey: 'Нет доступного пути развития навыков!',
    search_no_results: '- результатов нет!',
    no_image_generated: 'Изображения не сгенерированы!',
    all_topic_in_this_lesson:
      'Все темы в этом уроке будут удалены. Это действие необратимо.',
    content_has_been_generated: 'Контент для этой темы был сгенерирован.',
    update_course_template: 'Обновить шаблон курса',
    add_course_template: 'Добавить шаблон курса',
    create_course_now: 'Создать курс сейчас',
    preview_course: 'Предпросмотр курса',
    layout: 'Макет',
    import_from_youtube: 'Импортировать с YouTube',
    my_media_library: 'Моя медиатека',
    bg_added: 'Фон добавлен',
    add_bg: 'Добавить фон',
    booked_schedule: 'Запланированное расписание',
    add_schedule: 'Добавить расписание',
    are_you_delete_schedule: 'Вы уверены, что хотите удалить это расписание?',
    add_task: 'Добавить задачу',
    update_calender: 'Обновить календарь',
    manage_cookies: 'Управление куки',
    cookie_banner_text:
      'Мы используем куки для улучшения вашего опыта просмотра, анализа трафика сайта и персонализации контента. Ваша конфиденциальность важна для нас.',
    accept_all_cookies: 'Принять все куки',
    reject_all: 'Отклонить все',
    customize: 'Настроить',
    cookie_preferences_title: 'Настройки куки и конфиденциальности',
    privacy_subtitle:
      'Ваша конфиденциальность важна для нас. Выберите, с какими куки вы согласны. Вы можете изменить эти настройки в любое время.',
    save_choices: 'Сохранить мой выбор',
    strictly_necessary: 'Строго необходимые',
    strictly_necessary_desc:
      'Эти куки необходимы для корректной работы сайта. Они обеспечивают базовый функционал, такой как навигация по страницам, отправка форм и доступ к защищённым областям. Без них сайт не сможет работать должным образом.',
    analytics_performance: 'Аналитика и производительность',
    analytics_performance_desc:
      'Эти куки помогают нам понимать, как посетители взаимодействуют с нашим сайтом, собирая и отправляя информацию анонимно. Это помогает улучшать работу сайта и пользовательский опыт.',
    advertising_marketing: 'Реклама и маркетинг',
    advertising_marketing_desc:
      'Эти куки используются для того, чтобы рекламные сообщения были более релевантными для вас. Они предотвращают повторное появление одной и той же рекламы и обеспечивают корректное отображение рекламы для рекламодателей.',
    tracking_social: 'Отслеживание и социальные сети',
    tracking_social_desc:
      'Эти куки позволяют расширять функциональность и персонализировать контент, например, функции социальных сетей и персонализированный контент. Они могут устанавливаться нами или сторонними поставщиками.',
    functional: 'Функциональные',
    functional_desc:
      'Эти куки обеспечивают расширенный функционал, такой как чат-поддержка, онлайн-помощь и другие интерактивные возможности, улучшая ваш опыт на сайте.',
    your_rights: 'Ваши права:',
    rights_description:
      'Вы можете отозвать своё согласие в любое время, получить доступ к своим данным или запросить их удаление в любое время.',
    withdraw_consent: 'Отозвать все согласия',

    how_many_options: 'Сколько опций',
    add_content: 'Добавить контент',
    downloads_center: 'Центр загрузок',
    sharelook_help_center: 'Центр помощи Sharelook',
    channel_outline: 'Структура канала',
    channel_objectives: 'Цели канала',
    no_sop_available: 'Список СОП недоступен.',
    generate_world_summary: 'Сгенерировать сценарий',
    world_scenario: 'Сценарий реального мира',
    drag_icon_hint:
      'Совет: Перетащите значок на холсте, чтобы изменить его позицию',
    drag_text_hint:
      'Совет: Перетащите текст на холсте, чтобы изменить его позицию',
    edit_badge: 'Редактировать значок',
    create_new_badge: 'Новый значок',
    select_video_preview: 'Выберите видео для предварительного просмотра',
    certificate_title_required: 'Название сертификата обязательно',
    discard_changes: 'Отменить изменения',
    edit_certificate: 'Редактировать сертификат',
    add_another_logo: 'Добавить ещё один логотип',
    optional: 'Необязательно',
    doc: 'DOC',
    ppt: 'PPT',
    quest_title: 'Создать новое задание',
    quest_filter_title: 'Задание',
    sharelook_assistance: 'Помощь Sharelook',
    upload_scorm_zip: 'Загрузить Scorm Zip',
    only_letters_numbers_space_dot_allowed:
      'Допустимы только буквы, цифры, пробелы и точки!',
    video_playing: 'Воспроизведение',
    course_price_message:
      '*Курс будет доступен только пользователям внутри организации и не может продаваться на маркетплейсе.',
    lesson_must_be_positive: 'Количество уроков должно быть больше 1',
    btn_proceed: 'Продолжить',
    rule_select_music: 'Пожалуйста, выберите музыку',
    course_info: 'Информация о курсе',
    content_selection: 'Выбор контента',
    course_content_source: 'Источник контента курса',
    choose_how_to_source: 'Выберите, как получать контент для этого курса:',
    automatic_selection: 'Автоматический выбор',
    system_will_automatically_select_relavant_documents:
      'Система автоматически выберет соответствующие документы из вашей библиотеки',
    manual_selection: 'Ручной выбор',
    choose_specific_documents_from_your_library:
      'Выберите конкретные документы из вашей библиотеки',
    upload_files: 'Загрузить файлы',
    upload_new_documents:
      'Загрузите новые документы (PDF, DOC, DOCX, PPT, PPTX, TXT) - максимум 5 файлов',
    file: 'файл',
    ready_to_upload: 'готово к загрузке',
    clear_all: 'Очистить все',
    confirm_course_wide_premiew:
      'Подтвердить общий предварительный просмотр курса',
    generate_course_preview: 'Сгенерировать предварительный просмотр курса',
    instructions_across_the_course_to_generate:
      'Мы применим ваши инструкции ко всему курсу для генерации предварительного просмотра. Сначала всё проверьте, затем решите, сохранить или отменить изменения.',
    instruction_to_preview_course_wide:
      'Инструкции для общего предварительного просмотра курса:',
    edit_content: 'Редактировать контент',
    manage_course_template: 'Управление шаблоном курса',
    undo: 'Отменить',
    apply_changes: 'Применить изменения',
    characters: 'символов',
    apply_all: 'Применить ко всем',
    apply_to_all: 'Применить ко всем',
    use_this_content: 'Использовать этот контент',
    original: 'Оригинал',
    edited: 'Изменено',
    edited_content_preview: 'Предварительный просмотр изменённого контента',
    apply_edits_to_all_topices: 'Применить изменения ко всем тем?',
    current_editing_instructions_across_the_whole_course:
      'Это применит ваши текущие инструкции ко всему курсу. Вы можете просмотреть комбинированный предварительный просмотр перед сохранением.',
    edit_content_instructions: 'Инструкции по редактированию контента',
    generate_content_for_this_topic_instruction:
      'Сгенерировать контент для этой темы согласно вашим инструкциям',
    descrip_edit_content:
      'Опишите, как редактировать этот контент (например, сократить, упростить, перефразировать)',
    try_short_clear_direcctives:
      'Используйте короткие и чёткие инструкции. Примеры: «сократить до 100 слов, сохранить ключевые моменты», «упростить язык», «сделать более кратким и убрать лишнее».',
    we_preserve_the_core_meaning:
      'Мы сохраняем основное значение при применении ваших инструкций.',
    feedback_optional: 'Отзыв (необязательно)',
    write_your_feedback_here: 'Напишите ваш отзыв здесь',
    from_web: 'С веб-сайта',
    from_desktop: 'С компьютера',
    pleae_wait_processing: 'Пожалуйста, дождитесь завершения обработки...',
    create_simulation_from_screen_capture:
      'Создать симуляцию из захвата экрана',
    sharelook_not_found: 'ShareLook не найден',
    sharelook_screen_capture_application_not_be_opened:
      'Приложение ShareLook Screen Capture не удалось открыть. Возможно, оно не установлено на вашем компьютере.',
    download_sharelook: 'Скачать ShareLook',
    launch_sharelook_application: 'Запустить приложение ShareLook',
    this_will_open_the_sharelook_application_for_screen_capture:
      'Это откроет приложение ShareLook для захвата экрана.',
    sharelook_dosenot_open:
      'Если ShareLook не открывается, возможно, оно не установлено на вашем компьютере.',
    open_sharelook: 'Открыть ShareLook',
    download_app: 'Скачать приложение',
    background_image_setting: 'Настройки фонового изображения',
    current_image: 'Текущее изображение',
    change_image: 'Изменить изображение',
    remove_image: 'Удалить изображение',
    no_background_image_selected: 'Фоновое изображение не выбрано',
    add_image: 'Добавить изображение',
    this_will_open_for_screen_recording:
      'Это откроет приложение ShareLook для записи экрана.',
    ai_image_generation: 'Генерация изображения AI',
    image_edit: 'Редактирование изображения',
    text_to_image: 'Текст в изображение',
    output_gallary: 'Галерея результатов',
    instant_generation: 'Готово для мгновенной генерации',
    prompt_and_unleash_the_power: 'Введите подсказку и раскройте потенциал',
    use_this_image: 'Использовать это изображение',
    error_generating: 'Ошибка при генерации.',
    generation_tips: 'Советы по генерации',
    detailed_descriptions_for_more_accurate_results:
      'Используйте подробные описания для более точных результатов',
    reference_image: 'Референсное изображение',
    select_pixel_image: 'Выберите пиксельное изображение',
    max_mb: 'Максимум 50 МБ',
    please_enter_text_to_appear_image:
      'Введите текст, который появится на изображении',
    enter_text_to_apear_in_the_image:
      'Введите текст, который появится на изображении',
    generate_image: 'Сгенерировать изображение',
    prompt_assistant: 'Помощник подсказок',
    generate_image_using_suggested_prompt:
      'Сгенерировать изображение с использованием предложенной подсказки',
    talk_to_ai_about_the_image_generate:
      'Обсудите с AI изображение, которое хотите сгенерировать',
    ask_for_prompt_suggestions: 'Запросить предложения подсказок...',
    enter_a_search_term_to_find_stock_images:
      'Введите поисковый запрос для поиска стоковых изображений',
    choose_your_content_source: 'Выберите источник контента:',
    upload_new_document_from_your_device:
      'Загрузить новые документы с вашего устройства',
    automatic_library_selection: 'Автоматический выбор из библиотеки',
    system_automatically_selects_relevant_document:
      'Система автоматически выбирает соответствующие документы',
    manual_library_selection: 'Ручной выбор из библиотеки',
    generate_content: 'Сгенерировать контент',
    add_to_current_page: 'Добавить на текущую страницу',
    generate_bullet_points: 'Сгенерировать ключевые моменты',
    generating: 'Генерация',
    this_may_take_a_few_moments: 'Это может занять несколько минут',
    apply_to_page: 'Применить на странице',
    scenario_escription: 'Описание сценария:',
    feedback: 'Обратная связь',
    form_mode: 'Режим формы',
    chat_mode: 'Режим чата',
    this_will_generate_a_continuation_of_the_seleccted_story:
      'Это сгенерирует продолжение выбранной истории с помощью ИИ.',
    continue_this_story_question: 'Продолжить эту историю?',
    continue_this_story: 'Продолжить эту историю',
    what_will_happen: 'Что произойдет:',
    the_ai_will_analyze_the_existing_story_content:
      'ИИ проанализирует существующее содержание истории',
    generate_a_natural_continuation_that_follows_the_same_tone:
      'Создайте естественное продолжение, следующее тому же тону и стилю',
    create_new_content_that_build_upon_the_current_narrative:
      'Создайте новый контент, который расширяет текущий сюжет',
    this_process_may_take_a_few_moments_to_complete:
      'Этот процесс может занять несколько мгновений.',
    no_existing_stories_found_for_this_course:
      'Для этого курса не найдено существующих историй.',
    create_your_first_story: 'Создайте свою первую историю',
    existing_stories: 'Существующие истории',
    create_new_story: 'Создать новую историю',
    tone: 'Тон',
    style: 'Стиль',
    genre: 'Жанр',
    loading_your_stories: 'Загрузка ваших историй...',
    edit_story: 'Редактировать историю',
    story_preferences: 'Настройки истории',
    please_input_your: 'Пожалуйста, введите ваш',
    add_character_names_and_press_enter:
      'Добавьте имена персонажей и нажмите Enter',
    select_or_type_your: 'Выберите или введите ваш',
    enter_your: 'Введите ваш',
    position_of_the_story_in_the_lesson:
      'Позиция истории в уроке. История будет добавлена как блок в указанное место.',
    save_previous_content_on_the_pages:
      'Сохранить предыдущий контент на страницах',
    the_existing_content_in_the_selected_pages:
      'Существующее содержание на выбранных страницах будет заменено сгенерированной историей.',
    real_world_scenario: 'Сценарий из реального мира',
    add_optional_instructions:
      'Добавьте необязательные инструкции (тон, длина, аудитория и т.д.)',
    ready_to_enerate_your_real_world_scenario:
      'Готово к генерации вашего сценария из реального мира',
    click_generate_real_world_scenario_to_create_a_realistic_scenario:
      'Нажмите "Создать сценарий из реального мира", чтобы создать реалистичный сценарий на основе содержания вашего урока.',
    the_ai_will_analyze_your_lesson_topic_and_content:
      'ИИ проанализирует тему вашего урока и содержание',
    generate_a_practical_real_world_scenario:
      'Создать практический сценарий из реального мира',
    you_can_then_edit_and_customize_the_result:
      'Вы можете редактировать и настраивать результат',

    add_it_as_a_new_page_to_your_lesson:
      'Добавить как новую страницу к вашему уроку',
    regenerate_with_instructions: 'Сгенерировать заново с инструкциями',
    add_real_world_scenario: 'Добавить сценарий из реального мира',
    generate_real_world_scenario: 'Создать сценарий из реального мира',
    simulation_has_been_stopped: 'Симуляция остановлена!',
    loading_simulation: 'Загрузка симуляции...',
    you_have_exhausted_all_the_attempts: 'Вы исчерпали все попытки',
    study_the_scenario_on_this_page_and_select_the_correct_answer:
      'Изучите сценарий на этой странице и выберите правильный ответ из приведенных вариантов.',
    attempts_limit_reached:
      'Достигнут лимит попыток. Вы можете сыграть снова, но ваш результат не будет сохранен.',
    play_again: 'Играть снова',
    import_music_from_computer: 'Импортировать музыку с компьютера.',
    more: 'больше',
    no_badge_yet: 'Значков пока нет',
    competition_filter: 'Фильтр соревнований',
    global_leaderboard: 'Глобальная таблица лидеров',
    placeholder_for_the_global_leaderboard:
      'Это место для глобальной таблицы лидеров.',
    badge_editor: 'Редактор значков',
    adjust_the_appearance_of_this_badge_icon:
      'Настройте внешний вид этого значка. Изменения применяются только к этому значку.',
    badge_style: 'Стиль значка',
    the_image_must_be_pixels: 'Изображение должно быть 200x200 пикселей.',
    badge_name: 'Название значка',
    badge_descrription: 'Описание значка',
    enter_badge_criteria: 'Введите критерии значка',
    discard: 'Отменить',
    badge_enable: 'Значки включены',
    award_users_with_badges_to_highlight_the_milestones:
      'Награждайте пользователей значками, чтобы выделить ключевые этапы в их обучении.',
    badge_types: 'Типы значков',
    enable_or_disable_specific_badge_types_for_your_users:
      'Включите или отключите определенные типы значков для пользователей.',
    levels_enabled: 'Уровни включены',
    level_rules: 'Правила уровня',
    points: 'Баллы',
    add_new_level: 'Добавить новый уровень',
    add_level: 'Добавить уровень',
    points_enabled: 'Баллы включены',
    learning_activities_and_encourage_healthy_competition:
      'Награждайте пользователей баллами за различные учебные активности и поощряйте здоровую конкуренцию.',
    award_points: 'Наградить баллами',
    the_following_equates_the_value_of_one_item_completion:
      'Следующее эквивалентно завершению одного элемента',
    general: 'Общее',
    others: 'Другие',
    certificate: 'Сертификат',
    quiz_passed: 'Тест пройден',
    tip_approved: 'Совет одобрен',
    tip_liked: 'Совет понравился',
    rewards: 'Награды',
    offer_discounts_when_learners_achieve:
      'Предлагайте скидки, когда учащиеся достигают набора баллов, значков или уровней.',
    give_rewards: 'Выдать награды',
    discount_course_purchases_by: 'Скидка на покупку курса на',
    with_points_more_than: 'с баллами более',
    with_badges_more_than: 'с значками более',
    with_level_upwards_more_than: 'с уровнем выше',
    leaderboard: 'Таблица лидеров',
    leaderboard_enabled: 'Таблица лидеров включена',
    leaderboards_offer_users_an_overview_of_their_learning_progress:
      'Таблицы лидеров дают пользователям обзор их прогресса в обучении по сравнению с другими.',
    show_levels: 'Показать уровни',
    show_points: 'Показать баллы',
    show_badges: 'Показать значки',
    show_courses: 'Показать курсы',
    show_certificates: 'Показать сертификаты',
    leaderboard_settings: 'Настройки таблицы лидеров',
    set_up_engaging_leaderboard_experiences_to_boost_learner_motivation:
      'Настройте интересный опыт таблицы лидеров для повышения мотивации учащихся.',
    award_users_with_points_for_different_learning_activities:
      'Награждайте пользователей баллами за различные учебные активности.',
    badge_set: 'Набор значков',
    choose_the_type_of_badges_your_users:
      'Выберите тип значков, которые пользователи будут зарабатывать во время обучения.',
    levels: 'Уровни',
    Levels_represent_the_stages:
      'Уровни представляют этапы в обучении пользователя.',
    enabled: 'Включено',
    disabled: 'Отключено',
    quick_select: 'Быстрый выбор',
    yesterday: 'Вчера',
    last_week: 'На прошлой неделе',
    Last_month: 'В прошлом месяце',
    last_quarter: 'В прошлом квартале',
    historical_leaderboard: 'Историческая таблица лидеров',
    track_your_performance_and_see_how_you_rank_among_your_peers:
      'Отслеживайте свои результаты и смотрите, как вы ранжируетесь среди сверстников',
    time_period: 'Период',
    page_of: 'Страница 1 из 1',
    edit_competition: 'Редактировать соревнование',
    create_competition: 'Создать соревнование',
    arrow_right: 'стрелка-вправо',
    update_competition: 'Обновить соревнование',
    competition_title: 'Название соревнования',
    enter_competition_title: 'Введите название соревнования',
    enter_competition_description: 'Введите описание соревнования',
    leaderboard_skill: 'Навык',
    select_a_skill: 'Выберите навык',
    no_skills_found: 'Навыки не найдены',
    competition_period: 'Период соревнования',
    add_badge_rule: 'Добавить правило значка',
    create_badge: 'Создать значок',
    add_level_rule: 'Добавить правило уровня',
    selected_participants: 'Выбранные участники',
    no_participants: 'Нет участников',
    start_end_date: 'Дата начала–окончания',
    created_date: 'Создано',
    new_competition: 'Новое соревнование',
    competitions_list: 'Список соревнований',
    search_competitions: 'Поиск соревнований...',
    are_you_sure_you_want_to_delete_the_competition:
      'Вы уверены, что хотите удалить соревнование',
    history: 'История',
    export: 'Экспорт',
    search_by_name: 'Поиск по имени...',
    no_historical_data_available_for_the_selected_period:
      'Нет исторических данных за выбранный период.',
    no_leaderboard_data_available: 'Нет данных таблицы лидеров.',
    competitions: 'Соревнования',
    leaderboards: 'Таблицы лидеров',
    welcome_back: 'С возвращением',
    track_your_performance_and_see:
      'Отслеживайте свои результаты и смотрите свой рейтинг',
    team_leaderboard: 'Командная таблица лидеров',
    try_again: 'Попробовать снова',
    no_competitions_for_search: 'Нет соревнований для поиска',
    no_competitions_available: 'Нет доступных соревнований',
    no_competitions_matching_search:
      'Не найдено соревнований, соответствующих вашему поиску. Попробуйте изменить условия поиска или проверьте позже.',
    no_competitions_general:
      'В настоящее время соревнования не настроены. Проверьте позже или свяжитесь с администратором для создания новых соревнований.',
    media_management: 'Управление медиа',
    badgess_set: 'Набор значков',
    choose_the_default_visual_style_for_badge:
      'Выберите стиль значков по умолчанию, используемый на платформе.',
    enable_badges: 'Включить значки',
    add_badge: 'Добавить значок',
    min: 'Мин',
    max: 'Макс',
    your_rank: 'Ваш рейтинг',
    your_points: 'Ваши баллы',
    your_level: 'Ваш уровень',
    rank: 'Рейтинг #',
    level: 'Уровень',
    progress: 'Прогресс',
    new_folder: 'Новая папка',
    file_upload: 'Загрузка файла',
    writer: 'Автор',
    text_documents: 'Текстовые документы',
    spreadsheets: 'Таблицы',
    impress: 'Презентация',
    presentations: 'Презентации',
    capture_desktop_screen: 'Снимок экрана рабочего стола',
    capture_desktop_screens: 'Снимки экранов рабочего стола',
    your_documents: 'Ваши документы',
    manage_your_videos_images_audio_files:
      'Управляйте своими видео, изображениями, аудиофайлами и другими ресурсами, используемыми в создании контента.',
    your_organization_documents: 'Документы вашей организации',
    keep_your_organization_creative_assets_organized:
      'Держите креативные ресурсы вашей организации организованными и доступными—оптимизируйте совместную работу и производство контента.',
    your_public_documents: 'Ваши публичные документы',
    curated_collection_of_media_assets_available:
      'Кураторская коллекция медиа-ресурсов, доступная для всех—исследуйте, переиспользуйте и создавайте.',
    your_download_center_documents: 'Документы вашего центра загрузки',
    repository_of_approved_media_assets_for_download:
      'Репозиторий утвержденных медиа-ресурсов для скачивания и использования в ваших проектах.',
    search_files_and_folders: 'Поиск файлов и папок..',
    home: 'Главная',
    folders: 'Папки',
    folder_name: 'Название папки',
    owner: 'Владелец',
    last_updated: 'Последнее обновление',
    action: 'Действие',
    no_folders_found: 'Папки не найдены',
    files: 'Файлы',
    enabling_ai: 'Включение ИИ...',
    rename: 'Переименовать',
    copy: 'Копировать',
    move: 'Переместить',
    verson_history: 'История версий',
    manage_permission: 'Управление доступом',
    generate_audit_report: 'Создать отчет аудита',
    last_edited: 'Последнее редактирование',
    no_files_found: 'Файлы не найдены',
    are_you_sure_you_want_to_make_this_item_public:
      'Вы уверены, что хотите сделать этот элемент публичным? Он будет скопирован в вашу публичную библиотеку.',
    move_to_organization: 'Переместить в организацию',
    are_you_sure_you_want_to_copy_this_item_to_your_organization_library:
      'Вы уверены, что хотите скопировать этот элемент в библиотеку вашей организации?',
    are_you_sure_you_want_to_make_this_item_private:
      'Вы уверены, что хотите сделать этот элемент приватным? Он будет скопирован в вашу личную библиотеку.',
    date_modified: 'Дата изменения',
    workflow_management: 'Управление рабочим процессом',
    configure_editors_approvers_and_viewers_for_this_document:
      'Настройте редакторов, утверждающих и зрителей для этого документа.',
    error_Loading_editor: 'Ошибка загрузки редактора',
    debug_info: 'Информация для отладки',
    loading_editor: 'Загрузка редактора...',
    submitted_for_review: 'Отправлено на проверку',
    editors: 'Редакторы',
    no_editors_added_yet:
      'Редакторы еще не добавлены. Нажмите "Добавить редактора".',
    add_editor: 'Добавить редактора',
    approvers: 'Утверждающие',
    no_approvers_added_yet:
      'Утверждающие еще не добавлены. Нажмите "Добавить утверждающего".',
    add_approvers: 'Добавить утверждающего',
    viewer: 'Зритель',
    no_viewers_added_yet:
      'Зрители еще не добавлены. Нажмите "Добавить зрителя".',
    add_viewer: 'Добавить зрителя',
    are_you_sure_you_want_to_delete_the_selected_items:
      'Вы уверены, что хотите удалить выбранные элементы?'
  },
  v3: {
    reportShareSphere: 'Общая среда',
    overview: 'Обзор категории',
    triviaReport: 'Категория ShareSphere',
    overviewGraph: 'График обзора категории',
    category: 'Категория',
    phCategory: 'Выберите категорию',
    podcast: 'Подкаст, музыка и истории',
    pastPodcast: 'Прошлые подкасты',
    upcomingPodcast: 'Предстоящие подкасты',
    podcastLanguageTitle: 'Язык подкаста, музыки и историй',
    podcastLanguageCheckbox: 'Использовать ИИ для языка моего подкаста',
    howRate: 'Как вы оцениваете этот подкаст?',
    podcastSubmit: 'Отправить',
    podcastGuest: 'Приглашённый спикер:',
    podcastReview: 'Отзывы',
    podcastEpishode: 'Эпизод',
    podcastEnd: 'Подкаст завершён',
    date_podcast: 'Дата подкаста',
    skill_not_found: 'Извините! Путь навыков не найден.',
    coaching: 'Обучение',
    webinar: 'Вебинар',
    public_conference: 'Публичная конференция',
    skill_journey_subtitle:
      'Настройте свой путь навыков и выберите, кто может просматривать и взаимодействовать с ним.',
    enable_white_label: 'Включить White Label',
    create_new_event_org: 'Создать новое событие для вашей организации',
    create_new_event_marketplace: 'Создать новое событие для маркетплейса',
    create_new_event_both:
      'Создать новое событие для вашей организации и маркетплейса',
    event_outline: 'Введите план события',
    event_obj: 'Введите цели события',
    event_description: 'Введите описание события',
    create_new_metamaze_org: 'Создать новый MetaMaze для вашей организации',
    create_new_metamaze_marketplace: 'Создать новый MetaMaze для маркетплейса',
    create_new_metamaze_both:
      'Создать новый MetaMaze для вашей организации и маркетплейса',
    add_key_words: 'Добавить ключевые слова',
    press_enter_make_keyword: 'Нажмите Enter, чтобы создать ключевое слово',
    disable_skip_quiz: 'Отключить пропуск викторины',
    warning_complete_quiz: 'Пожалуйста, завершите викторину, чтобы продолжить.',
    signup_email_verification:
      'Мы отправили ссылку для подтверждения на вашу почту. Пожалуйста, перейдите по ссылке для подтверждения регистрации.',
    verifying_registration: 'Проверка регистрации...',
    reset_password_linK:
      'Мы отправили ссылку для сброса пароля на вашу почту. Пожалуйста, перейдите по ссылке для создания нового пароля.',
    reset_email_error:
      'Пользователь с таким email не найден, попробуйте использовать имя пользователя!',
    first_name: 'Имя',
    last_name: 'Фамилия',
    error_firstName: 'Пожалуйста, введите имя',
    error_sharebot_organization: 'Пожалуйста, введите организацию',
    error_lastName: 'Пожалуйста, введите фамилию',
    private_conference: 'Частная конференция',
    public_conference: 'Публичная конференция',
    discussion_room: 'Комната для обсуждений',
    training_no_courses: 'Вы пока не участвуете ни в одном курсе.',
    training_no_events: 'Вы пока не участвуете ни в одном событии.',
    allow_sharing_trainer_info:
      'Разрешить маркетплейсу делиться электронной почтой',
    error_username_space: 'Имя пользователя не может содержать пробелы.',
    error_sharebot_organization_space:
      'Название организации не может содержать пробелы.',
    edit_permission: 'Разрешение на редактирование',
    valid_price: 'Цена должна быть больше 0',
    course_price_message: `*Курсы доступны только для пользователей, купивших через организацию, и не могут быть перепроданы на маркетплейсе`,
    valid_edit_price: 'Цена редактирования должна быть меньше цены покупки.',
    my_calendar: 'Мой календарь',
    error_valid_firstName: 'Пожалуйста, введите корректное имя.',
    error_valid_organization:
      'Пожалуйста, введите корректное название организации.',
    error_valid_lastName: 'Пожалуйста, введите корректную фамилию.',
    error_name_spaces: 'Имя не должно содержать пробелов',
    items: 'Элементы',
    publish_to_channel: 'Опубликовать в моей коллекции каналов',
    create_a_channel: 'Создать мой канал',
    create_a_trivia: 'Создать викторину',
    create_a_new_channel: 'Создать новый канал',
    add_videos: 'Добавить видео',
    save_and_continue: 'Сохранить и продолжить',
    channel: 'Канал',
    channels: 'Каналы',
    view_channel: 'Просмотр канала',
    edit_channel: 'Редактировать канал',
    delete_channel: 'Удалить канал',
    my_video_channels: 'Мои видео каналы',
    training_no_channel: 'Вы пока не участвуете ни в одном канале.',
    monthly_price_required: 'Требуется месячная цена',
    yearly_price_required: 'Требуется годовая цена',
    one_time_price_required: 'Требуется одноразовая цена',
    marketplace_quantity: 'Доллары США',
    report_webinar: 'Вебинар',
    report_coaching: 'Обучение',
    report_channel: 'Канал',
    report_public_conference: 'Публичная конференция',
    report_maze: 'Лабиринт',
    channel: 'Канал',
    edit_price: 'Изменить цену ($)',
    quantity: 'Количество',
    payment_type: 'Тип оплаты',
    total_amount: 'Общая сумма ($)',
    net_amount: 'Чистая сумма ($)',
    edit_option: 'Изменить опцию',
    marketplace_price: 'Цена ($)',
    market_name: 'Название',
    duration_min: 'Продолжительность (минуты)',
    users_total: 'Пользователи (всего)',
    sales_total: 'Всего продаж (доллары)',
    search_coaching: 'Поиск обучения',
    search_channel: 'Поиск канала',
    search_webinar: 'Поиск вебинара',
    search_maze: 'Поиск лабиринта',
    search_public_conference: 'Поиск публичной конференции',
    buyer_type: 'Тип покупателя',
    quanity: 'Количество',
    channel_unit_amount: 'Чистая сумма ($)',
    channel_updated_at: 'Обновлено',
    month_price: 'Цена (в месяц)',
    year_price: 'Цена (в год)',
    one_time_price: 'Цена (однократно)',
    sharebot_organization: 'Добавить новое название организации',
    share_sphere: 'Общая среда',
    ai_course_title: 'Название курса',
    ai_input_course_title: 'Пожалуйста, введите название курса!',
    learning_objective_label: 'Цель обучения',
    learning_objective_message: 'Пожалуйста, укажите цель обучения!',
    standard_question:
      'Есть ли стандарты, которым должен следовать обучающийся?',
    standard_details_label: 'Детали стандартов',
    standard_details_message: 'Пожалуйста, укажите детали стандартов!',
    estimated_duration_label:
      'Предполагаемая продолжительность курса (в минутах)',
    estimated_duration_message:
      'Пожалуйста, укажите предполагаемую продолжительность!',
    min_duration_message: 'Минимальная продолжительность - 5 минут.',
    ai_mins: '25 мин',
    industry_specific_question: 'Это отраслевой курс?',
    industry_label: 'Укажите отрасль',
    industry_message: 'Пожалуйста, укажите отрасль!',
    ai_course_creation: 'Создание курса с ИИ',
    course_generated: 'Курс создан с помощью Sharelook',
    ai: 'ИИ',
    ai_you: 'Вы',
    ai_prompt_ready: 'Ваш запрос готов. Теперь вы можете создать оглавление.',
    ai_unable_respond:
      'Извините! ИИ не может обработать ваш запрос. Пожалуйста, попробуйте снова.',
    ai_hide_toc: 'Скрыть оглавление',
    ai_preview_toc: 'Предпросмотр оглавления',
    ai_generate_toc_now: 'Создать оглавление сейчас',
    ai_creation_course_title: 'Название курса:',
    ai_creation_industry_specific: 'Это отраслевой курс:',
    ai_creation_industry: 'Отрасль:',
    ai_creation_standard_needed:
      'Есть ли стандарты, которым должен следовать обучающийся?:',
    ai_creation_standard_details: 'Детали стандартов:',
    ai_creation_estimated_duration:
      'Предполагаемая продолжительность курса (в минутах):',
    minutes: 'минут',
    ai_creation_learning_objective: 'Цель обучения:',
    setup_again: 'Настроить заново',
    ai_creation_confirm_title: 'Вы уверены, что хотите сбросить форму?',
    ai_creation_confirm_content:
      'Чат и все сгенерированные материалы будут сброшены.',
    ai_toc: 'Оглавление',
    ai_note_topic:
      'Примечание: Вы можете перетаскивать темы внутри урока для изменения порядка.',
    ai_add_topic: '+ Добавить тему',
    add_topic: 'Добавить тему',
    add_lesson: 'Добавить урок',
    add_new_lesson: 'Добавить новый урок',
    ai_add_lesson: '+ Добавить урок',
    attention: 'Внимание',
    before_varifying: 'Перед проверкой',
    ai_save_later: 'Сохранить на потом',
    ai_download_word_doc: 'Скачать как документ Word',
    ai_download_course_word_doc: 'Скачать курс как документ Word',
    ai_create_course_button: 'Создать курс',
    ai_generate_course_content: 'Сгенерировать содержание курса',
    ai_out_of: 'из',
    ai_subtopic_failed_content:
      'подтемы не удалось сгенерировать. Нажмите "Сгенерировать содержание курса" еще раз, чтобы создать содержание только для этих подтем.',
    ai_edit_topic: 'Редактировать тему',
    ai_edit_lesson_title: 'Редактировать название урока',
    ai_save_topic: 'Сохранить тему',
    ai_save: 'Сохранить',
    ai_save_lesson_title: 'Сохранить название урока',
    ai_add_new_topic: 'Добавить новую тему',
    ai_download_ref: 'Скачать с ссылками',
    ai_download_ref_content: 'Курс будет скачан как документ Word с ссылками.',
    ai_download_without_ref: 'Скачать без ссылок',
    ai_download_two_word: 'Будут скачаны два документа Word:',
    ai_download_two_word_content_one:
      '- один с основным содержанием без ссылок,',
    ai_download_two_word_content_two:
      'и другой, содержащий только список ссылок без основного содержания.',
    ai_manage_content: 'Управление содержанием',
    ai_add_content_from_internet: '+Добавить содержание из интернета',
    ai_confirm_start: 'Подтвердить начало',
    ai_Verify: 'Проверить',
    ai_undo_warning:
      'Этот процесс может занять некоторое время. Пожалуйста, не закрывайте окно до завершения генерации, так как это нельзя отменить.',
    ai_verified_content:
      'Вы проверили содержание. Обратите внимание, что после подтверждения вы не сможете вернуться к чату с ИИ-ассистентом для текущего содержания.',
    ai_want_proceed: 'Вы уверены, что хотите продолжить?',
    upload_simulation: 'Загрузить симуляцию',
    name_simulation: 'Название симуляции',
    selected_simulation_files: 'Выбранные файлы симуляции',
    score_between_one_hundred: 'Ваша оценка должна быть от 1 до 100.',
    are_sure_simulation: 'Вы уверены, что хотите удалить этот файл симуляции?',
    required_simulation: 'Требуется оценка',
    required_section_file: 'Требуется файл раздела',
    simulation: 'Симуляция',
    simulation_quiz_games: 'Необходимо добавить викторину в игры',
    simulation_alert_des:
      'Вы можете добавить игры только если все вопросы имеют тип ответа "один" или "несколько".',
    alert_info: 'информация',
    ai_number_quiz: 'Количество викторин',
    ai_point: 'Балл',
    ai_points: 'Баллы',
    val_required: 'Обязательно',
    games: 'Игры',
    add_simulation: 'Добавить симуляцию',
    text_tiewer: 'Просмотр текста',
    back_to_account: 'Вернуться в аккаунт',
    delete_account: 'Удалить аккаунт',
    delete_account_title: 'Удалить аккаунт ???',
    delete_account_subtitle: 'Вы можете удалить свой аккаунт здесь.',
    delete_account_cannot_undo:
      'Вы собираетесь удалить свой аккаунт. Это действие нельзя отменить.',
    account_org_profile:
      'Вы также потеряете все созданные курсы, профиль организации и все настройки.',
    deleting_account_database:
      'Удаление аккаунта приведет к удалению всех ваших данных из нашей базы.',
    account_confirm_delete: 'Вы уверены, что хотите удалить свой аккаунт?',
    action_cannot_be_undone: 'Это действие нельзя отменить.',
    account_delete_message_success: 'Ваш аккаунт успешно удален.',
    message_edit: 'Редактировать',
    message_delete: 'Удалить',
    message_reply: 'Ответить',
    attached_file: 'Прикрепленный файл',
    attach_file: 'Прикрепить файл',
    attach_des: 'Максимальный размер файла - 25 МБ',
    view: 'Просмотр',
    go_to_marketplace: 'Перейти в Маркетплейс',
    learning_center: 'Учебный центр',
    knowledge_center: 'Центр знаний',
    sharebot: 'ShareBot',
    sharebot_help_message: 'Чем я могу вам помочь сегодня?',
    my_organization: 'Моя организация',
    world_knowledge: 'Мировые знания',
    welcome_to_sharelook: 'Добро пожаловать в Sharelook !',
    sharelook_you_want_go: 'Куда вы хотите пойти сегодня?',
    shareLook_learning_management_system:
      'Доступ к системе управления обучением ShareLook для создания или доступа к учебным ресурсам, таким как живые события и курсы в вашей организации на ShareLook.',
    shareLook_powerful_ai_system:
      'Доступ к мощной системе ShareLook с ИИ, где вы можете загружать PDF-документы и получать полезную информацию за секунды. Получайте быстрые ответы на основе ресурсов, загруженных в вашей организации, или ответы от нашей общей ИИ-системы в разделе мировых знаний.',
    edit_now: 'Редактировать сейчас',
    sharelook_log_out: 'Вы вышли из Sharelook. Пожалуйста, войдите снова!',
    sorry_error: 'Извините! Произошла ошибка.',
    login: 'Войти',
    refresh_page: 'Обновить страницу',
    just_a_moment: 'Один момент',
    enter_lname_fname:
      'Пожалуйста, введите ваше имя и фамилию для продолжения.',
    procced_to_sharelook: 'Перейти в Sharelook',
    option_one: 'Вариант 1',
    option_two: 'Вариант 2',
    selected_image: 'Выбранное изображение:',
    add_text: 'Добавить текст',
    linkdin_is_required: 'Требуется LinkedIn.',
    bio_is_required: 'Требуется биография.',
    save_user_information: 'Сохранить информацию о пользователе',
    select_all: 'Выбрать все',
    enable_ai: 'Включить ИИ',
    load_more: 'Загрузить больше',
    channel_id: 'ID канала.',
    send: 'Отправить',
    v4: 'Информация',
    subscription: 'Подписка',
    reset_user_flag: 'СБРОС ФЛАГА ПОЛЬЗОВАТЕЛЯ',
    delete_my_accont: 'Удалить мой аккаунт',
    sharebot_sub_error: 'Ошибка при получении подписок. Попробуйте снова!',
    sharebot_no_sub: 'У вас сейчас нет активных подписок.',
    sharebot_dont_sub: 'У вас нет предыдущих подписок.',
    sharebot_prev_sub: 'Ранее подписаны',
    sharebot_sub: 'Подписка на ShareBot',
    sharebot_un_sub: 'Отмена подписки на ShareBot',
    sharebot_no_available: 'Описание недоступно',
    sharebot_start_date: 'Дата начала:',
    sharebot_end_date: 'Дата окончания:',
    sharebot_sure: 'Вы уверены?',
    sharebot_do_you_want: 'Вы хотите',
    unsubscribe: 'отписаться',
    unsubscribe_what: 'отписаться?',
    subscribe: 'подписаться',
    subscribe_what: 'подписаться?',
    subscribe_now: 'подписаться сейчас',
    confirm: 'Подтвердить',
    sharebot_intel_knowledge_center: 'Интеллектуальный центр знаний ShareBot',
    sharebot_welcome_paragraph:
      'Добро пожаловать в Центр знаний ShareBot, продвинутого ИИ-чата, предназначенного для преобразования способа доступа профессионалов к информации и сотрудничества.',
    expired: 'Истек',
    active: 'Активен',
    Inactive: 'Неактивен',
    yearly_subscription: 'Годовая подписка',
    monthly_subscription: 'Месячная подписка',
    no_sharebot_org: 'У вас нет организации Sharebot',
    sharebot_start_free_trial: 'Начать бесплатную пробную версию',
    sub_month: 'Месячная подписка',
    sub_year: 'Годовая подписка',
    question_per_month: 'Хранение данных (1 ТБ) и 1000 вопросов в месяц',
    sharebot_para:
      'Продолжая, вы подтверждаете немедленное удаление организации. Это действие приведет к потере всех ценных данных, предоставленных ShareBot, и не может быть отменено.',
    cancelled_date: 'Дата отмены:',
    live_straming_para:
      'Если вы хотите изменить ваш месячный лимит на трансляции, пожалуйста, свяжитесь с',
    sharelook_agree: 'Я согласен с',
    terms_condition: 'условиями и положениями',
    and: 'и',
    privacy_policy: 'политикой конфиденциальности',
    save_for_later: 'Сохранить на потом',
    ai: 'ИИ',
    no_video_yet: 'Видео еще не выбрано!',
    are_you_sure_delete_video: 'Вы уверены, что хотите удалить это видео?',
    video_des: 'Описание',
    video_now: 'Сейчас',
    video_playing: 'Воспроизведение:',
    video_no: 'Видео №',
    ai_generated_course: 'Курс, созданный ИИ',
    create_course_on_our_own: 'Создать курс самостоятельно',
    ai_Assisted_ourse_reation: 'Создание курса с помощью ИИ',
    pending: 'В ожидании',
    published: 'Опубликовано',
    intro_course: 'в ваш курс?',
    clone_course: 'Хотите клонировать',
    browser_audio_not_support: 'Ваш браузер не поддерживает аудио тег.',
    audio_popup_content:
      'Где вы можете использовать множество голосовых стилей для текста, который вы вводите бла бла бла Lorem Ipsum - это просто фиктивный текст печатной и наборной индустрии. Lorem Ipsum был стандартным фиктивным текстом в индустрии с 1500-х годов,',
    close: 'Закрыть',
    podcast_rec: 'ЗАПИСЬ',
    create_podcast: 'Создать подкаст',
    add_admin: 'ДОБАВИТЬ АДМИНА',
    delete_all: 'Удалить все',
    ai_podcast_audio: 'Аудио подкаста с ИИ',
    language: 'Язык',
    podcast_download_content:
      '*Скачайте аудиофайл ИИ для редактирования, чтобы он стал вашим аудиофайлом.',
    upload_audio: 'Загрузить аудио',
    browser_do_not_support_audio: 'Ваш браузер не поддерживает аудио элемент.',
    upload_cover: 'Загрузить обложку',
    upload_ai_creator: 'Создатель ИИ',
    required_cover_image: 'Требуется обложка!',
    room_required_name: 'Требуется название подкаста!',
    add_guest_list: 'Пожалуйста, добавьте список гостей!',
    podcast_add_participants: 'ДОБАВИТЬ УЧАСТНИКА',
    topic_required: 'Требуется хотя бы одна тема',
    podcast_description: 'ОПИСАНИЕ',
    podcast_date: 'ДАТА',
    date: 'Дата',
    podcast_time: 'время',
    podcast_to: 'до',
    podcast_all_day: 'Весь день',
    podcast_start_date_time: 'Требуется дата начала и временной интервал!',
    podcast_id: 'ID',
    selected_user: 'Пригласить выбранных пользователей',
    see_more: 'Показать больше',
    see_less: 'Показать меньше',
    no_review_yet: 'Пока нет отзывов, будьте первым.',
    request_to_speak: 'Принять запрос пользователя на выступление?',
    kick_user: 'Вы хотите исключить этого пользователя?',
    accept_request: 'Принять запрос',
    kick: 'ИСКЛЮЧИТЬ',
    started: 'НАЧАЛО',
    end: 'КОНЕЦ',
    join_now: 'Присоединиться сейчас',
    podcast_end: 'Подкаст завершен',
    connecting: 'подключение...',
    knowledge_center_know_today: 'Что вы хотите узнать сегодня?',
    knowledge_center_question: 'Пожалуйста, сначала введите вопрос',
    knowledge_center_error: 'Извините! Произошла ошибка.',
    knowledge_center_tooltrip:
      'Получайте быстрые ответы из учебных ресурсов в репозитории вашей организации на ShareLook, с соответствующими ссылками и возможностью предпросмотра и загрузки указанных PDF-документов.',
    my_organization: 'Моя организация',
    world_knowledge: 'Мировые знания',
    open_file: 'Открыть файл',
    reference: 'Ссылка',
    are_you_cancel: 'Вы уверены, что хотите отменить?',
    are_you_remove_media: 'Вы уверены, что хотите удалить медиа?',
    terms_agree: 'Я согласен с этими',
    ready: 'Готово',
    send_email: 'ОТПРАВИТЬ EMAIL',
    active_users: 'Активные пользователи',
    sign_up_user: 'Зарегистрированные пользователи',
    non_sign_up_user: 'Незарегистрированные пользователи',
    organisation: 'Организация',
    usage_report: 'Отчет об использовании',
    check_email: 'проверьте вашу почту',
    delete_schedule: 'Удалить расписание',
    are_you_sure_delete_schedule:
      'Вы уверены, что хотите удалить это расписание?',
    add_task: 'Пожалуйста, введите задачу!',
    coaching_available: 'Отметить как доступность для коучинга',
    message_booking_coaching:
      'Это время забронировано пользователем для коучинга.',
    task_day: 'День задачи',
    created_task_day: 'Вы создали задачу на этот день.',
    event_day: 'День события',
    has_booked_coaching: 'На этот день забронирован коучинг.',
    active_day: 'Активный день',
    selectable_time_slots:
      'Выбираемые временные интервалы справа активны для этого дня.',
    compare_last_month: 'По сравнению с прошлым месяцем',
    uploading_file: 'Загрузка вашего файла',
    attach_file_course: 'прикреплен к этому курсу.',
    fetch_request: 'Получение вашего запроса',
    finilize_upload: 'Завершение загрузки',
    scorm_scanned:
      'Пожалуйста, подождите... Ваш загруженный SCORM-архив сканируется.',
    scan_status: 'Статус сканирования:',
    scan_completed: 'Сканирование завершено. Ваш файл',
    scan_progress: 'Сканирование в процессе...',
    check_scorm:
      'Проверка формата вашего SCORM-файла... Пожалуйста, подождите...',
    file_check_success: 'Проверка файла успешна',
    file_check_progress: 'Проверка файла в процессе...',
    scorm_not_upload:
      'Ваш загруженный файл не соответствует стандарту SCORM 1.2, пожалуйста, загрузите файл снова.',
    select_question: 'Варианты ответа (выберите один правильный ответ)',
    select_answer: 'Пожалуйста, выберите вариант ответа!',
    check_option_one: 'Пожалуйста, введите вариант один!',
    check_option_two: 'Пожалуйста, введите вариант два!',
    check_option_three: 'Пожалуйста, введите вариант три!',
    check_option_four: 'Пожалуйста, введите вариант четыре!',
    question_image: 'Изображение вопроса',
    select_question_image: 'Пожалуйста, выберите изображение вопроса!',
    ans_image: 'Изображение ответа',
    upload_image_question: 'Загрузить изображение ответа',
    select_image_answer: 'Пожалуйста, выберите изображение ответа!',
    save_question: 'Сохранить вопрос',
    do_you_leave: 'Вы уверены, что хотите выйти?',
    loose_all_progress: 'Вы потеряете весь ваш прогресс.',
    welcome: 'Добро пожаловать',
    team_knowledge_quest: 'Командный поиск знаний',
    your_score: 'Ваш счет',
    start_playing: 'Начать игру',
    share_sphere_complete: 'ShareSphere завершен',
    final_score: 'Итоговый счет',
    play_next: 'Играть дальше',
    you_donot_access_event: 'У вас нет доступа к этому событию.',
    ai_content_generated: 'Содержание для этой темы было сгенерировано.',
    ai_popup_confirm_content: 'Подтвердить генерацию содержания',
    limit_transcribe_text:
      'Оставшееся время расшифровки: <0>{{ transcribe_limit }}</0> минут <1/><2/> <3>. Чтобы изменить лимит расшифровки, пожалуйста, свяжитесь с </3> <4>admin@sharelook.com</4>.',
    you_donot_access_event: 'У вас нет доступа к этому событию.',
    ai_course_title_training: 'Курсы по развитию лидерских качеств',
    ai_course_object: 'Ориентиры лидерства в цифровую эпоху',
    create_ai_video: 'Создать AI-видео',
    generate: 'СГЕНЕРИРОВАТЬ',
    video_generate_process:
      'Процесс генерации видео может занять некоторое время. После завершения вы получите уведомление по электронной почте.',
    stripe_account_connect:
      'Ваша учетная запись Stripe неактивна. Пожалуйста, подключите или активируйте её, чтобы продолжить.',
    ai_creator: 'AI-Создатель',
    check_video_status: 'Проверка статуса генерации видео...',
    video_on_queue: 'Видео поставлено в очередь на генерацию.',
    video_fail_generation:
      'К сожалению, генерация видео не удалась. Пожалуйста, попробуйте другое.',
    video_currently_generated: 'Это видео в настоящее время генерируется.',
    checking_status: 'Проверка статуса',
    check_status: 'Проверить статус',
    browser_does_not_support_audio: 'Ваш браузер не поддерживает тег audio',
    existing_edit_scenario:
      'Вы хотите отредактировать существующий сценарий или создать новый? Если вы создадите новый, старый сценарий будет удалён.',
    generate_scenario: 'Сгенерировать сценарий',
    layout: 'Макет',
    confirm_change: 'Подтвердить изменение',
    generated_ai_creation_message:
      'Обратите внимание: будут сохранены только текстовые элементы, сгенерированные AI. Все другие элементы будут удалены со страницы.',
    generate_story: 'Сгенерировать рассказ',
    save_original_content: 'Сохранить оригинальный контент:',
    story_added_specified_position:
      'Положение рассказа в уроке. Он будет добавлен в виде блока в указанную позицию.',
    position_of_story: 'Положение рассказа',
    start_the_lesson: 'Начало урока',
    end_the_lesson: 'Конец урока',
    add_story_pages: 'Добавить рассказ на страницы',
    browser_does_not_support: 'Ваш браузер не поддерживает аудиоэлемент.',
    no_video_available: 'Нет доступных видео.',
    no_podcast_available: 'Нет доступных подкастов.',
    no_item_baskets: 'Корзина пуста.',
    ai_course_object: 'Ориентиры лидерства в цифровую эпоху'
  },
  v2: {
    n_data: 'Нет данных',
    change: 'Изменить',
    remove: 'Удалить',
    auto_background: 'Автофон',
    create_new_course_org: 'Создайте новый курс для вашей организации.',
    create_new_course_marketplace: 'Создайте новый курс для маркетплейса.',
    create_new_course_both:
      'Создайте новый курс для вашей организации и маркетплейса.',
    ok: 'Ок',
    page_bg: 'Фон страницы',
    lesson_cover: 'Обложка урока',
    create_skill_journey: 'Создать путь навыков',
    Metamaze: 'Metamaze',
    events: 'События',
    scroms: 'SCORMы',
    min_score_pass: 'Минимальный балл для прохождения',
    no_scorms_available: 'Нет доступных SCORMов.',
    no_events_available: 'Нет доступных событий.',
    no_courses_available: 'Нет доступных курсов.',
    no_courses_baskets: 'Нет курсов в корзине.',
    no_mazes_baskets: 'Нет лабиринтов в корзине.',
    no_scroms_baskets: 'Нет SCORMов в корзине.',
    no_events_baskets: 'Нет событий в корзине.',
    sorry: 'Извините!',
    option_1: 'Вариант 1',
    option_2: 'Вариант 2',
    enter_number_words: 'Введите максимальное количество слов.',
    summarize: 'Резюмировать',
    answer: 'Ответ',
    hold_tight_one_minute:
      'Подождите немного! Мы все еще готовим. Это может занять до минуты.',
    enter_question: 'Введите ваш вопрос.',
    enter_relevant_documents: 'Введите количество релевантных документов.',
    please_input_relevant_documents:
      'Пожалуйста, введите количество релевантных документов!',
    please_wait_loading_results:
      'Пожалуйста, подождите загрузки результатов...',
    proceed_to_add_voice: 'Перейти к добавлению голоса',
    results: 'Результаты',
    no_result_found_try_asking_questions:
      'Результатов не найдено. Попробуйте задать больше вопросов.',
    eg: 'например,',
    what_make_sales_manager: 'Что может сделать меня менеджером по продажам?',
    please_select_lang: 'Пожалуйста, выберите язык!',
    search: 'Поиск',
    please_copy_desired_content:
      'Пожалуйста, скопируйте нужное содержимое из левого блока в правый.',
    rating_req: 'Оценка — обязательное поле.',
    review_req: 'Отзыв — обязательное поле.',
    rating_review_req: 'Необходимо указать и оценку, и отзыв.',
    how_rate_this: 'Как бы вы это оценили?',
    amazing_above_expectations: 'Потрясающе! Превзошло ожидания!',
    certificates: 'Сертификаты',
    you_no_certificates: 'У вас нет доступных сертификатов на данный момент.',
    please_add_review: 'Пожалуйста, оставьте отзыв вместе с оценкой. Спасибо!',
    post: 'Опубликовать',
    rate: 'Оценить',
    avg_rating: 'Средняя оценка',
    no_review_found: 'Отзывов не найдено',
    are_sure_to_disale_zoom_integration:
      'Вы уверены, что хотите отключить интеграцию с Zoom?',
    badges: 'Значки',
    you_no_badge_available: 'У вас нет доступных значков на данный момент.',
    download_certificate: 'Скачать сертификат',
    loading: 'Загрузка...',
    no_file_attached: 'Файлы не прикреплены',
    you_do_not_have_any_notes: 'У вас нет заметок.',
    question: 'Вопрос',
    score: 'Баллы',
    alert_score_message: 'Участник(и) отправили свои баллы.',
    alert_question_message: 'Вопросы пока не добавлены.',
    button_submit: 'Отправить',
    button_allScores: 'Все баллы отправлены.',
    record_wait: 'Запись начинается. Пожалуйста, подождите...',
    buttonSubmit_warning: 'Пожалуйста, введите все баллы перед отправкой.',
    upload_ar_assets: 'Загрузить AR-ресурсы',
    edit_ar_assets: 'Редактировать AR-ресурсы',
    edit_maze_assets: 'Редактировать ресурсы MetaMaze',
    upload_assets: 'Загрузить ресурсы',
    upload_maze_assets: 'Загрузить ресурсы MetaMaze',
    trigger_title: 'Название триггера',
    model_title: 'Название модели',
    trigger_description: 'Описание триггера',
    model_description: 'Описание модели',
    please_type_target_description: 'Пожалуйста, введите описание цели.',
    please_type_model_description: 'Пожалуйста, введите описание модели.',
    trigger_image: 'Изображение триггера*',
    model_image: 'Изображение модели*',
    upload_trigger_image: 'Загрузить изображение триггера',
    upload_model_image: 'Загрузить изображение модели',
    drag_n_drop: 'Перетащите и отпустите',
    file_size_should_not_exceed:
      '(Размер файла изображения (JPEG) не должен превышать 512 КБ)',
    zip_size_should_not_exceed: '(Размер ZIP-файла не должен превышать 60 МБ)',
    ar_content: 'AR-контент*',
    model_content: '3D-модель*',
    upload_3d_zip: 'Загрузить ZIP / Видео',
    upload_3d_maze_zip: 'Загрузить ZIP',
    audio_content: 'Аудиоконтент',
    _mp3: '(.mp3)',
    content_attached: 'ZIP файл прикреплен.',
    video_attached: 'Видео прикреплено.',
    audio_attached: 'Аудио прикреплено.',
    enter_trigger_image_title: 'Введите название изображения триггера.',
    enter_model_title: 'Введите название модели MetaMaze.',
    ar_preview_image: 'Превью изображения AR',
    upload_preview_image: 'Загрузить превью изображения',
    upload_audio: 'Загрузить аудио',
    creating___: 'Создание...',
    updating___: 'Обновление...',
    create: 'Создать',
    update: 'Обновить',
    ar_assets: '3D-изображение',
    _3d_files_mp4: '(Архив .obj, .fbx или видео .mp4)',
    _3d_files_mp4_ar: '(Архив .obj, .fbx)',
    maze_3d_files_mp4: '(Архив .obj, .fbx)',
    _jpg_files: 'Поддерживаются только .jpg',
    persons_have_submitted_their_scores: 'Человек(а) отправили свои баллы.',
    no_questions_added_till_now: 'Вопросы пока не добавлены.',
    submit: 'Отправить',
    all_scores_submitted: 'Все баллы отправлены.',
    recording_is_starting: 'Запись начинается. Пожалуйста, подождите...',
    please_input_scores_before_submitting:
      'Пожалуйста, введите все баллы перед отправкой.',
    end_for_all: 'Завершить для всех',
    full_screen: 'Полный экран',
    breakout_room: 'Комната для совещаний',
    send_invitations: 'Отправить приглашения',
    add_participants: 'Добавить участников',
    create_breakout_room: 'Создать комнату для совещаний',
    connecting: 'Подключение...',
    currently_broadcaster_unavailable: 'В данный момент вещатель недоступен.',
    how_many_breakout_room_to_create:
      'Сколько комнат для совещаний вы хотите создать?',
    create_upto_three_breakout_rooms: '*Создайте до 3 комнат для совещаний',
    allow: 'Разрешить',
    additional: 'Дополнительно',
    attachment: 'Вложения',
    no_description_available: 'Описание недоступно.',
    people: 'ЛЮДИ',
    waiting: 'Ожидание',
    hand_raising_users: 'Пользователи, поднимающие руку',
    invite: 'Пригласить',
    create_room: 'Создать комнату',
    create_live_event: 'Создать прямой эфир',
    support_upto_fivethousand_participants:
      'Поддержка до 5000 участников мероприятия',
    support_upto_ten_participants:
      'Поддержка до 10 участников с видео в прямом эфире',
    support_upto_twohundred_participants:
      'Поддержка до 200 участников мероприятия',
    supprt_upto_five_participants:
      'Поддержка до 5 участников с видео в прямом эфире',
    support_upto_twentyfive_participants:
      'Поддержка до 25 участников с видео в прямом эфире для мероприятия',
    two_live_video_participants:
      'В мероприятии участвуют 2 участника с видео в прямом эфире (ведущий и участник)',
    you_can_have_upto_five_examinees:
      'Вы можете иметь не более 5 экзаменуемых.',
    you_can_have_upto_twentyfive_participants:
      'Вы можете иметь не более 25 участников.',
    you_can_have_upto_five_participants:
      'Вы можете иметь не более 5 участников.',
    you_can_have_upto_ten_participants:
      'Вы можете иметь не более 10 участников.',
    select_hosts_email: 'Выберите электронную почту ведущего',
    send_invite_email: 'Отправить приглашение по электронной почте',
    do_not_send_invite_email: 'Не отправлять приглашение по электронной почте',
    error: 'Ошибка',
    max_twentyfive_users_allowed:
      'Максимум разрешено выбирать 25 пользователей',
    max_five_users_allowed: 'Максимум разрешено выбирать 5 пользователей',
    max_ten_users_allowed: 'Максимум разрешено выбирать 10 пользователей',
    no_user_found: 'Пользователь не найден',
    transcribe_to: 'Транскрибировать в',
    integrate_zoom_to_start_meeting:
      'Интегрируйте Zoom в свой аккаунт, чтобы начать встречу Zoom.',
    zoom_is_not_integrated: 'Zoom не интегрирован.',
    delete_poll: 'Удалить опрос',
    add_poll: 'Добавить опрос',
    live_now: 'ПРЯМОЙ ЭФИР!',
    average_rating: 'Средний рейтинг',
    review: 'Отзыв',
    time_spent: 'Потраченное время',
    total: 'Итого',
    mins: 'Минуты',
    no_data: 'Данные для этого теста отсутствуют.',
    total_score: 'Общий балл',
    pass_score: 'Проходной балл',
    point: 'Баллы',
    wrong: 'Неверно',
    response: 'Ответ',
    submitted: 'Отправлено',
    average: 'Среднее',
    total_play: 'Всего запусков',
    view_graph: 'Просмотреть график',
    time_spent_mins: 'Потраченное время (минуты)',
    play: 'Играть',
    ideal_path: 'Идеальный путь',
    user_incorrect_path: 'Неверный путь пользователя',
    ideal_path_taken: 'Идеальный путь, выбранный пользователем',
    scenario: 'Сценарий',
    option: 'Вариант',
    spend: 'Потрачено',
    average_spending_time: 'Среднее время на выполнение',
    activity_overview: 'Обзор активности',
    live_event: 'Прямое событие',
    live_assessment: 'Прямое оценивание',
    report_download: 'Скачать отчёт',
    all_workshops: 'Все мастер-классы',
    overview_average_activity: 'Обзор средней активности',
    overview_workshop_graph: 'График обзора мастер-классов',
    mazes: 'Лабиринты',
    correct_feedback: 'Правильная обратная связь',
    incorrect_feedback: 'Неправильная обратная связь',
    checkin_checkout: 'Регистрация входа - выхода',
    minutes: 'Минуты',
    incorrect_path: 'Неверный путь',
    answer_not_available: 'Ответ недоступен',
    views: 'Просмотры',
    item: 'Элемент',
    questions: 'Вопросы',
    total_points: 'Общее количество баллов',
    total_attempts: 'Всего попыток',
    created_date: 'Дата создания',
    host_name: 'Имя ведущего',
    host_section: 'Раздел ведущего',
    choose_products: 'Выберите продукты',
    add_to_basket: 'Добавить в корзину',
    basket: 'Корзина',
    times: 'Раз',
    scorms: 'SCORMs',
    skill_journey_overview: 'Обзор пути навыков',
    how_to_use: 'Как использовать',
    live_broadcast_description:
      'МЫ ИНТЕГРИРОВАЛИ ВИДЕО В РЕАЛЬНОМ ВРЕМЕНИ В УДОБНЫЙ КОНСТРУКТОР КУРСОВ',
    live_broadcast_subdescription:
      'С помощью запатентованной системы прямых трансляций ShareLook вы можете создавать вовлечённость, автоматизировать обучение и максимизировать обмен знаниями.',
    disclaimer: `Я гарантирую, что мой путь навыков не будет:
  - нарушать права третьих лиц
  - содержать какой-либо незаконный контент, включая клевету, непристойности, пошлость, насилие, оскорбления, угрозы или дискриминационный контент, даже замаскированный звездочками
  - содержать личные нападения на других лиц
  - выдавать себя за других участников, публичных лиц или знаменитостей
  - содержать записи или личную информацию о любом человеке без его согласия и не нарушать законодательство о защите данных в любой части мира
  - содержать коммерческие предложения или любой вид спама`,
    price: 'Цена',
    video_link: 'Ссылка на видео',
    category: 'Категория',
    objectives: 'Цели',
    marketplace_description: 'Описание маркетплейса',

    live_discussion: 'ПРЯМАЯ ДИСКУССИЯ',
    poll: 'ОПРОС',
    hide_grid: 'Скрыть сетку',
    show_grid: 'Показать сетку',
    stop_screen_share: 'Остановить демонстрацию экрана',
    screen_share: 'Демонстрация экрана',
    mute: 'Выключить звук',
    unmute: 'Включить звук',
    raise_hand: 'Поднять руку',
    waiting__: 'Ожидание...',
    audio_active: 'Аудио активно'
  },
  general: {
    save: 'Сохранить',
    autosaved: 'Сохранено автоматически',
    back_to: 'Назад к',
    by: 'от',
    chat: 'Чат',
    completed: 'Завершено',
    canceled: 'Отменено',
    component: 'Компонент',
    confirm: 'Подтвердить',
    course: 'Курс',
    skill: 'Путь навыков',
    maze: 'МетаЛабиринт',
    channel: 'Канал',
    podcast: 'Подкаст',

    date: 'Дата',
    details: 'Детали',
    empty: 'Нет данных',
    enrolled: 'Зачислен',
    free: 'Бесплатно',
    graph: 'График',
    loading: 'Загрузка...',
    lesson: 'занятие',
    lessons: 'занятия',
    live_assessment: 'Оценивание в режиме реального времени',
    live_event: 'Прямая трансляция',
    no: 'Нет',
    of: 'Из',
    or: 'Или',
    organization: 'Организация',
    page: 'Страница',
    pages: 'Страницы',
    personal: 'Личный',
    poll: 'Опрос',
    rating: 'Рейтинг',
    reset: 'Сбросить',
    signin: 'Войти',
    signup: 'Зарегистрироваться',
    soon: 'Вскоре',
    type: 'Тип',
    uploading: 'Загрузка...',
    yes: 'Да',
    something_went_wrong: 'Что-то пошло не так!',
    view_all: 'Просмотреть все',
    upload_successful: 'Загрузка успешно завершена',
    upload_successful_message:
      'Ваши документы Excel успешно загружены и в настоящее время обрабатываются. Это может занять некоторое время.',
    check_email_upload_successful:
      'Пожалуйста, <0>проверьте свою электронную почту</0> на предмет наличия <1>отчета</1> о загруженном списке пользователей.',
    is_private: 'Приватный'
  },

  account: {
    title: 'Аккаунт',
    subtitle: 'Управляйте настройками и информацией о своем аккаунте.',
    saved: 'Аккаунт успешно изменен'
  },

  assessments: {
    title: 'Оценивание',
    subtitle: 'Создать оценивание',
    finished: 'Оценивание завершено',
    countdown:
      ' Оценивание в режиме реального времени будет транслироваться через ',
    create: 'Создать оценивание',
    list_title: 'Ваши оценивания',
    delete_warning: 'Вы уверены, что хотите удалить этот элемент?',
    details_title: 'Добавить детали оценивания',
    details_subtitle:
      'Дайте название своему оцениванию и расскажите аудитории, чего они должны ожидать от него.',
    disclaimer: `Я гарантирую, что записанное мной оценивание не будет: I
    - нарушать права третьих лиц
    - содержать противозаконные действия, то есть не будет содержать клеветческий, непристойный, неприличный, пошлый, порнографический, насильственный, оскорбительный, обидный, угрожающий или дискриминационный контент, даже замаскированный звездочками
    - содержать каких-либо личных нападок на других лиц
    - содержать любую выдачу себя за других участников, общественных деятелей или знаменитостей
    - содержать каких-либо записей или личной информации о каком-либо человеке без согласия такого лица и не будет нарушать какие-либо правила защиты данных в любой части мира
    - содержать коммерческих предложений или «спама» в любой форме`
  },

  buildersettings: {
    title: 'Опубликовать настройки',
    subtitle:
      'Добавьте настройки для вашего мероприятия относительно того, кто может просматривать и взаимодействовать с вашим мероприятием'
  },

  buttons: {
    market_place: 'Market Place',
    back_to_normal: 'Back To Normal',
    add: 'Добавить',
    add_page: 'Добавить страницу',
    add_lesson: 'Добавить занятия',
    add_answer: 'Добавить новый ответ',
    add_group: 'Добавить группу',
    add_organization: 'Добавить организацию',
    add_question: 'Добавить вопрос',
    add_quiz: 'Добавить викторину',
    add_users: 'Добавить пользователей',
    back: 'Назад',
    back_to_course: 'Назад к обзору курса',
    back_to_lesson: 'Назад к обзору занятия',
    back_to_media: 'Назад в медиатеку',
    back_to_details: 'Назад к деталям',
    cancel: 'Отмена',
    clear: 'Очистить',
    close: 'Закрыть',
    clone: 'Клонировать',
    close_lesson: 'Закрыть занятие',
    clone_course: 'Клонировать курс',
    confirm: 'Подтвердить',
    create: 'Создать',
    download: 'Скачать',
    download_mass_user_tamplate: 'Скачать шаблон',
    add_mass_users: 'Добавить массовых пользователей',
    upload_excel_list: 'Загрузить список Excel',
    delete: 'Удалить медиа',
    edit: 'Редактировать',
    edit_course: 'Редактировать курс',
    enroll: 'Записаться',
    finish: 'Завершить',
    upload_image: 'Загрузить изображение',
    upload_image_video: 'Загрузить изображение или видео',
    select_media_library: 'Выбрать медиатеку',
    make_public: 'Сделать публичным',
    make_private: 'Сделать приватным',
    make_org: 'Создать организацию',
    media: 'Медиатека',
    my_theme: 'Моя тема',
    next: 'Далее',
    next_lesson: 'Следующее занятие',
    next_step: 'Следующий шаг',
    previous_step: 'Предыдущий шаг',
    publish: 'Опубликовать',
    publish_assessment: 'Опубликуйте свое оценивание',
    publish_course: 'Опубликуйте свой курс',
    publish_event: 'Опубликуйте свое мероприятие',
    reset: 'Сбросить',
    reset_elements: 'Сбросить элементы',
    save: 'Сохранить',
    creating: 'Создание...',
    updating: 'Сохранение...',
    saved: 'Сохранено',
    save_for_later: 'Сохранить на потом',
    save_settings: 'Сохранить настройки',
    select_files: 'Выбрать файлы',
    select_theme: 'Выбрать тему',
    start_lesson: 'Начать занятие',
    update: 'Обновить',
    upload: 'Загрузить',
    upload_audio: 'Загрузить аудио',
    upload_photo: 'Загрузить фото профиля',
    upload_video: 'Загрузить видео',
    enrolled: 'Зачислен',
    unenroll: 'Покинуть',
    from_library: 'Медиатека',
    remove: 'Удалить',
    removed: 'Удалено',
    start_broadcast: 'Начать трансляцию',
    end_broadcast: 'Завершить трансляцию',
    camera: 'Камера',
    screen: 'Экран',
    screen_with_camera: 'Экран с камерой'
  },

  card: {
    quick_add: 'Быстрое добавление',
    add: 'Добавить',
    clone: 'Клонировать курс',
    completed: 'завершенные занятия'
  },

  course: {
    upcoming_course: 'Предстоящий курс',
    unPublishEvent: 'Отменить публикацию мероприятия',
    unPublishAssessment: 'Отменить публикацию оценивания',
    pastCourse: 'Учебный курс',
    upcoming: 'Предстоящие прямые трансляции',
    pastEvent: 'Прошедшие прямые трансляции',
    pastAssessment: 'Прошедшие оценивания в режиме реального времени',
    upcomingAssessment: 'Предстоящие оценивания в режиме реального времени',
    created: 'Дата создана:',
    assignees: 'Уполномоченные лица',
    organisations:
      ' {{ organizations }} Организации, <2> {{ users }} пользователи</2>',
    event_date: 'Дата прямой трансляции<1> {{ date }} </1>',
    delete_warning: 'Вы уверены, что хотите удалить это?',
    clonning_no_lesson:
      'Пожалуйста, добавьте хотя бы одно занятие, чтобы клонировать этот курс.',
    clone_warning: 'Вы уверены, что хотите клонировать это?',
    clone_success: 'находится в процессе клонирования',
    disclaimer: `Я гарантирую, что мой курс не:
    - нарушает права третьих лиц
    - содержит противозаконные действия, то есть не содержит клеветческий, непристойный, неприличный, пошлый, порнографический, насильственный, оскорбительный, обидный, угрожающий или дискриминационный контент, даже замаскированный звездочками
    - содержит каких-либо личных нападок на других лиц
    - содержит любую выдачу себя за других участников, общественных деятелей или знаменитостей
    - содержит каких-либо записей или личной информации о каком-либо человеке без согласия такого лица и не нарушает какие-либо правила защиты данных в любой части мира
    - содержит коммерческих предложений или «спама» в любой форме`
  },

  coursecreate: {
    dropzone_text: 'Вставить медиа',
    sidebar_text: 'Выберите тему<1/> для своих <3/> занятий',
    delete_warning: 'Вы уверены, что хотите удалить это занятие?'
  },

  coursepage: {
    quizview_loading: 'Проверка ответов. Пожалуйста, подождите...',
    quizview_answer: 'Ваш ответ'
  },

  coursequiz: {
    title: 'Викторины во всех занятиях'
  },

  dashboard: {
    tooltip_title: 'Больше не показывать это видео',
    page_title: 'Статистика ваших курсов',
    page_subtitle: 'Статус созданных вами курсов',
    profile_add_info:
      'Добавьте <1>{{uncompletedText}}</1>, чтобы завершить заполнение своего профиля.',
    profile_build:
      'Создайте свой профиль <1>здесь</1>, расскажите нам о своих интересах и навыках.',
    profile_title: 'Эффективность профиля',
    more_details: 'Детальнее'
  },

  errors: {
    answer: 'Пожалуйста, введите ответ',
    answer_correct: 'Выберите правильный ответ',
    code: 'Пожалуйста, введите свой код',
    criterion: 'Пожалуйста, введите критерий',
    duration: 'Продолжительность является обязательной',
    element: 'Пожалуйста, введите элемент',
    email: 'Пожалуйста, введите свой адрес электронной почты',
    email_invalid: 'Введен неверный адрес электронной почты',
    feedback_correct: 'Пожалуйста, введите правильный отзыв',
    feedback_incorrect: 'Пожалуйста, введите неверный отзыв',
    host: 'Пожалуйста, введите организатора мероприятия',
    host_assessment: ' Пожалуйста, введите организатора оценивания',
    image: 'Пожалуйста, загрузите изображение',
    location: 'Пожалуйста, введите свое местонахождение',
    live_location: 'Пожалуйста, выберите место трансляции',
    limit: 'Пожалуйста, введите минуты прямой трансляции',
    min_3char: 'минимум 3 символа',
    number: 'пожалуйста, введите положительное число.',
    host_email_require: `Адреса электронной почты организаторов являются обязательными.`,
    attendee_email_require: `Электронные адреса участников являются обязательными.`,
    name: 'Пожалуйста, введите свое имя',
    not_found_course: 'Курс не найден',
    not_found_event: 'Мероприятие не найдено',
    not_found_assessment: 'Оценивание не найдено',
    password: 'Пожалуйста, введите свой пароль',
    password_digit: 'Как минимум одна цифра',
    password_short: 'Пароль слишком короткий, минимум 10 символов',
    password_special: 'Как минимум один специальный символ',
    password_uppercase: 'Как минимум один символ верхнего регистра',
    password_lowercase: 'Как минимум один символ нижнего регистра',
    phone: 'Пожалуйста, введите номер своего телефона',
    phone_invalid: 'Неверный номер телефона',
    position: 'Пожалуйста, введите свою должность',
    question: 'Пожалуйста, введите вопрос',
    start_date: 'Дата и время начала являются обязательными',
    tag: 'Пожалуйста, выберите тег',
    topics: 'Пожалуйста, хотя бы одну тему.',
    live_topics: 'Пожалуйста, добавьте темы',
    title: 'Пожалуйста, введите название ',
    title_assessment: 'Пожалуйста, введите название оценивания',
    title_course: 'Пожалуйста, введите название курса',
    title_empty: 'Поле названия не может быть пустым',
    title_event: 'Пожалуйста, введите название мероприятия',
    title_lesson: 'Пожалуйста, введите название занятия',
    title_quiz: 'Пожалуйста, введите название викторины',
    username: 'Пожалуйста, введите свое имя пользователя',
    upload_error: 'Ошибка – файл несовместим!',
    upload_more_than_10: 'За раз вы можете загрузить не более 10 файлов.',
    topics_max: 'Пожалуйста, добавьте максимум 3 темы.',
    upload_excel:
      'Пожалуйста, убедитесь в том, что вы загрузили правильный файл.',
    title_excel: 'Ошибка при загрузке шаблона:',
    file_size_exceed: 'Превышен размер файла',
    subtitle_excel:
      'Пожалуйста, убедитесь в том, что вы используете предоставленный шаблон и столбцы заполнены правильно.',
    select_broadcast_option:
      'Пожалуйста, выберите вариант для трансляции этого мероприятия',
    multi_hosts_number_error:
      'Количество ведущих не может превышать количество, определенное для мероприятия.',
    conference_people_number_error: `Количество участников не может превышать количества, указанного для мероприятия.`,
    select_max_host: 'Выберите как минимум 1 ведущего для мероприятия.',
    select_max_conference: 'Выберите как минимум 1 участника для мероприятия.',
    stream_stop_error: 'Потоковая передача неожиданно остановлена!',
    unsecure_context:
      'Неустранимая ошибка: браузер не может получить доступ к камере и микрофону из-за небезопасного контекста. Пожалуйста, установите SSL и получите доступ через https',
    ws_not_supported:
      'Неустранимая ошибка: WebSocket не поддерживается в этом браузере'
  },

  events: {
    title: 'Добавить детали прямой трансляции',
    change_host: 'Изменить организатора',
    finished: 'Мероприятие завершено',
    countdown: 'Прямая трансляция будет осуществляться через ',
    subtitle:
      'Дайте название своему мероприятию и расскажите аудитории, чего они должны ожидать от него.',
    poll_disabled: 'В этом мероприятии опрос недоступен',
    disclaimer: `Я гарантирую, что записанное мной событие не будет: 
    - нарушать права третьих лиц
    - содержать противозаконные действия, то есть не будет содержать клеветческий, непристойный, неприличный, пошлый, порнографический, насильственный, оскорбительный, обидный, угрожающий или дискриминационный контент, даже замаскированный звездочками
    - содержать каких-либо личных нападок на других лиц
    - содержать любую выдачу себя за других участников, общественных деятелей или знаменитостей
    - содержать каких-либо записей или личной информации о каком-либо человеке без согласия такого лица и не будет нарушать какие-либо правила защиты данных в любой части мира
    - содержать коммерческих предложений или «спама» в любой форме`,
    prompt_message:
      'Если вы покинете эту страницу, ваше мероприятие завершится. Вы уверены, что хотите покинуть эту страницу?',
    duration_exceed_message:
      'Время вашей трансляции превышает максимальное ограничение, приложение вскоре прекратит трансляцию.',
    before_schedule_message:
      'Вы собираетесь начать трансляцию раньше запланированного времени мероприятия. Обратите внимание, что остановка трансляции завершит мероприятие.',
    browser_unsupportive_message:
      'Ваш браузер не поддерживает демонстрацию экрана. Вы можете ознакомиться с поддерживаемыми браузерами по этой ссылке',
    cancel_switch_host_message:
      'Организатор недоступен. Мероприятие будет продолжено с вашего конца.',
    coaching_prompt_message:
      'Вы не можете покинуть эту страницу, пока мероприятие не закончится.',
    event_modal_warn: 'Вы хотите покинуть это мероприятие?',
    confirm_message: 'Ваше мероприятие закончится, если вы нажмете ОК.',
    screen_share_denied: 'Вы отказались предоставить доступ к вашему экрану',
    media_not_found:
      'Камера или микрофон не найдены или доступ к ним запрещен на вашем устройстве.',
    media_not_access:
      'Камера или микрофон используются другим процессом, который не позволяет считать устройства',
    constraint_error:
      'Не найдено ни одного устройства, которое бы соответствовало вашим требованиям к видео и аудио. Вы можете изменить ограничения видео и звука',
    media_access_denied: 'У вас нет доступа к камере и микрофону.'
  },

  filters: {
    days7: 'Последние 7 дней',
    days15: 'Последние 15 дней',
    days30: 'Последние 30 дней',
    days365: 'Последние 365 дней',
    date: 'Дата создана',
    relevance: 'Релевантность',
    popularity: 'Популярность',
    name: 'Имя',
    group: 'Группа',
    Newest_to_Oldest: 'От более новых к более старым',
    Oldest_to_Newest: 'От более старых к более новым',
    A_Z: 'От А до Я',
    Z_A: 'От Я до А'
  },

  helpers: {
    password:
      'Чтобы обеспечить безопасность вашего аккаунта, нам требуется как минимум один символ нижнего регистре и одну цифру в вашем пароле. Также минимальная длина должна составлять 10 символов.',
    phone: 'Пожалуйста, укажите телефонный код вашей страны, например: +65',
    username:
      'Ваше имя пользователя является общедоступной информацией и по мере необходимости передается другим пользователям. Поэтому мы рекомендуем вам не использовать личную информацию в своем имени пользователя',
    public_description_normal:
      'Ваш <0><0/></0> был сохранен и по умолчанию считается приватным. Это означает, что данный контент можете видеть только вы. Чтобы опубликовать этот контент, вы можете выбрать один из вариантов ниже. Публичная публикация курса означает, что он будет доступен всем пользователям платформы. Параметр «Определенные пользователи» позволит вам поделиться своим курсом с определенными пользователями, используя адрес электронной почты, связанный с их аккаунтом Sharelook.',
    public_description_admin:
      'Данный<0><0/></0> был сохранен и по умолчанию считается приватным. Это означает, что только вы (и создатель контента) можете видеть этот контент. Чтобы опубликовать этот контент, вы можете выбрать один из вариантов ниже. Публичная публикация курса означает, что он будет доступен для всех пользователей платформы, включая пользователей вне вашей организации. Публикация его для организации означает, что его смогут увидеть все пользователи организации. Вы также можете опубликовать его для одной или нескольких групп, то есть увидеть его смогут только пользователи этих групп. Наконец, у вас есть возможность опубликовать его для определенных пользователей внутри и за пределами вашей организации, используя адрес электронной почты их аккаунта Sharelook.'
  },

  labels: {
    add: 'Добавить',
    portrait: 'Crop Portrait',
    landscape: 'Crop Landscape',
    answer_type: 'Тип ответа',
    answers: 'Ответы',
    back_to_quiz: 'Назад к списку викторин',
    back_to_question: 'Назад к списку вопросов',
    chat: 'Чат',
    chat_available: 'В этом мероприятии чат недоступен',
    chat_report: 'Отчет о чате',
    choice_single: 'Единственный выбор',
    choice_multiple: 'Множественный выбор',
    choice_free: '"Свободный" выбор',
    choice_sorting: 'Выбор "порядка"',
    choice_matrix: `Выбор "матричного порядка`,
    clone_lesson_permission: 'Разрешение на клонирование',
    code: 'Код',
    correct: 'Правильно',
    created: 'Дата создана',
    clone_modal: 'Клонировать курс',
    cloning_course: 'Клонирование курса...',
    cloning: 'Клонирование...',
    cloning_course_desc:
      'Этому процессу потребуется некоторое время. Пожалуйста, будьте терпеливы',
    cloning_success: 'Клонирование курса "<0/>" успешно завершено!',
    description: 'Описание',
    disclaimer: 'Отказ от ответственности',
    drop_file: 'Перетащите файл сюда...',
    duration: 'Продолжительность',
    edit: 'Редактировать',
    email: 'Адрес электронной почты',
    event: 'Мероприятие',
    event_all: 'Все его мероприятия',
    event_date: 'Местная дата/время трансляции',
    event_this: 'Это мероприятие',
    expire: 'Срок действия',
    expiry_date: 'Дата завершения',
    forgot: 'Забыли пароль?',
    group: 'Группа',
    groups_list: 'Перечень групп',
    host: 'Организатор',
    id_annotation: 'Идентификатор аннотации',
    id_quiz: 'Идентификатор викторины',
    incorrect: 'Неправильно',
    interests: 'Интересы',
    invited: 'Приглашены',
    live_chat: 'Живое обсуждение',
    live_stream_limit: 'Минуты прямой трансляции',
    contact_text:
      'Чтобы изменить ежемесячный лимит прямых трансляций, пожалуйста, свяжитесь с',
    contact_admin:
      '<0>Если вы хотите изменить ежемесячный лимит прямых трансляций, пожалуйста, свяжитесь с </0> <1>admin@sharelook.com</1>',
    limit_stream_text:
      'Осталось минут прямой трансляции: <0>{{ limit }}</0> минут <1/><2/> <3>Чтобы изменить ежемесячный лимит прямых трансляций, пожалуйста, свяжитесь с</3> <4>admin@sharelook.com</4>',
    location: 'Местонахождение',
    lessons: 'Занятия',
    location_broadcast: 'Местонахождение сервера организатора',
    location_broadcast_subtitle:
      'Добавьте местонахождение, наиболее близкое к местонахождению организатора трансляции, чтобы уменьшить аудиовизуальную задержку',
    media_manager: 'Медиа-менеджер',
    minutes: 'Минуты',
    name: 'Название',
    online_quiz: 'Онлайн-викторина',
    organiser: 'Автор',
    organization: 'Организация',
    overall_emotion: 'Общий опыт:',
    organizations_list: 'Перечень организаций',
    password: 'Пароль',
    participants: 'Участники',
    picture: 'Картинка (16:9)',
    phone: 'Телефон',
    photo: 'Фото',
    poll: 'Опрос',
    position: 'Должность',
    processing: 'Обработка',
    privacy_settings: 'Настройки конфиденциальности',
    question: 'Вопрос',
    quiz_create: 'Создать новую викторину',
    quiz_name: 'Название викторины',
    quiz_update: 'Обновить викторину',
    select_organization: 'Выбрать организацию',
    settings: 'Настройки',
    show: 'Показать',
    show_graph: 'Показать результат графика',
    signin: 'Войти',
    signup: 'Зарегистрироваться',
    sort_by: 'Сортировать по',
    start_date: 'Дата начала',
    tags: 'Теги',
    terms: 'Я согласен с этими <1>условиями и положениями</1>.',
    title: 'Заголовок',
    topics: 'Темы',
    topic: 'Тема',
    total_comments: 'Всего комментариев',
    username: 'Имя пользователя',
    users_list: 'Список пользователей',
    users_emails: 'Вставьте адреса электронной почты конкретных пользователей',
    description_specifiction_email:
      'Пожалуйста, введите по одному адресу электронной почты в каждой строке, чтобы поделиться этим с несколькими конкретными пользователями.',
    message_specific_email:
      'Пожалуйста, введите адрес электронной почты конкретного пользователя.',
    viewers: 'Зрители',
    edit_course: 'Редактировать',
    edit_assessment: 'Редактировать',
    edit_event: 'Редактировать',
    delete_course: 'Удалить',
    delete_event: 'Удалить',
    delete_assessment: 'Удалить',
    view_course: 'Просмотреть',
    view_event: 'Просмотреть',
    view_assessment: 'Просмотреть',
    date_event: 'Дата прямой трансляции',
    date_assessment: 'Дата оценивания в режиме реального времени',
    clone_of: 'Клон',
    clone_course:
      'Создайте клон этого курса, который вы можете изменять независимо от оригинала, включая все занятия и страницы.',
    make: 'Сделать',
    available_to: 'доступным для любого пользователя ShareLook',
    uploaded_by: 'Загружено: ',
    course: 'Курс',
    assessment: 'Оценивание',
    user_not_exist:
      'Пользователь не существует, вы хотите отправить приглашение?',
    check_user: 'Уведомление',
    user_not_exist_in_org:
      'Пользователь не существует в этой организации, вы хотите отправить приглашение?',
    title_modal_stream: 'Изменить лимит прямой трансляции для организации',
    des_warning_stream: 'Вы собираетесь изменить',
    monthly_stream: 'месячный лимит прямой трансляции:',
    min_per_month: 'мин/месяц',
    broadcast_label: 'Я хочу сделать:',
    hosts_emails: `Вставить адреса электронной почты конкретных организаторов`,
    attendee_emails: `Вставить адреса электронной почты конкретных участников`,
    description_host_specifiction_email:
      'Пожалуйста, введите по одному адресу электронной почты в каждой строке.',
    presenter_label: 'Ведущий',
    presenter_label_conference: 'К-тво людей',
    event_privacy: 'Режим конференции'
  },

  broadcastOptions: {
    stream_from_phone: 'Прямая трансляция с моего телефона',
    other_webrtc: 'Вебинар с моего ПК',
    multihost: 'Многоканальный вебинар с моего ПК',
    peer2peer: 'Сеанс коучинга',
    conference: 'Конференция в режиме реального времени'
  },

  lessoncreate: {
    title: 'Добавить детали занятия',
    subtitle:
      'Дайте название своему занятию и расскажите аудитории, получение каких знаний они могут ожидать от него.',
    input_label_title: 'Название занятия',
    input_label_topics: 'Темы занятия',
    input_label_description: 'Описание занятия',
    delete_warning: 'Вы уверены, что хотите удалить эту страницу?'
  },

  lessonoverview: {
    title: 'Добавить занятие',
    subtitle: 'Добавьте существующее занятие или создайте новое',
    new_lesson: 'создайте новое занятие',
    new_lesson_sub: 'Создайте новое занятие с нуля!',
    existing_lesson: 'Выбрать существующее занятие',
    existing_lesson_sub:
      'Ссылка на существующее занятие, изменения, внесенные в это занятие, также повлияют на это занятие в других курсах.',
    clone_lesson: 'дублировать существующее занятие',
    clone_lesson_sub:
      'Создайте уникальную копию занятия из этого курса, изменения, внесенные в это занятие, не повлияют на исходное занятие.',
    clone_lesson_modal_sub:
      'Пожалуйста, нажмите кнопку клонирования под занятием, которое вы хотите добавить в свой курс.'
  },

  management: {
    groups_title: 'Управление группами',
    delete_warning: 'Вы уверены?',
    organizations_title: 'Мои организации',
    organizations_subtitle: 'Добавить организации в свой список',
    users_title: 'Управление пользователями',
    users_position: 'Старший менеджер по работе с клиентами',
    user_not_found: 'Пользователь не найден',
    select_org:
      'Пожалуйста, найдите и выберите организацию для управления пользователями'
  },

  audio: {
    modal_title: 'Вставить аудио',
    list_view: 'Просмотр списка',
    create_audio_modal_title: 'Создать аудио',
    edit_audio_modal_title: 'Редактировать аудио',
    public_audio_not_found: 'Аудио не найдено.',
    private_audio_not_found: 'Вы еще не загрузили ни одного аудио',
    are_you_sure_to_delete: 'Вы действительно хотите удалить?',
    type_something: 'Напечатайте что-нибудь',
    select_voice: 'Выбрать',
    file_name: 'Название файла',
    description: 'Описание',
    topic: 'Тема',
    key_words_tag: 'Тег ключевых слов',
    mp3_audio: 'MP3 аудио',
    created: 'Создано',
    duration: 'Продолжительность',
    close: 'закрыть'
  },

  image: {
    modal_title: 'Вставить изображение',
    image: 'Изображение',
    pixel: 'Пиксель',
    dimension: 'Размер',
    public_image_not_found: 'Изображение не найдено.',
    private_image_not_found: 'Вы еще не загрузили ни одного изображения'
  },

  annotation: {
    modal_title: 'Аннотация'
  },

  text: {
    modal_title: 'Текстовый редактор'
  },

  video: {
    modal_title: 'Вставить видео',
    image: 'Видео',
    mp4_video: 'MP4 видео',
    public_video_not_found: 'Видео не найдено.',
    private_video_not_found: 'Вы еще не загрузили ни одного видео'
  },

  media: {
    title: 'Медиатека',
    subtitle: 'Библиотека ваших файлов',
    modal_title: 'Загрузить медиафайл',
    delete_warning: 'Подтвердите удаление',
    delete_message:
      'Удаленные медиафайлы будут по-прежнему отображаться на тех страницах, где они использовались',
    dropzone_text: 'или перетащите',
    delete_success: 'Медиафайлы успешно удалены',
    upload_file: 'Загрузить файл',
    drag_drop: 'или перетащите',
    import_file: 'Импортируйте файл(ы) со своего компьютера',
    no_media: 'Вы еще не загрузили ни одного медиафайла',
    media_type: 'Тип медиафайла',
    video: 'Видео',
    image: 'Изображение',
    audio: 'Аудио',
    gif: 'GIF',
    transcribed_text: 'Transcribed Text',
    media_not_found: 'Медиафайл не найден.',
    of: 'из',
    disclaimer: `Я гарантирую, что мои медиафайлы не:
    - нарушают права третьих лиц
    - содержат противозаконные действия, то есть не содержат клеветческий, непристойный, неприличный, пошлый, порнографический, насильственный, оскорбительный, обидный, угрожающий или дискриминационный контент, даже замаскированный звездочками
    - содержат каких-либо личных нападок на других лиц
    - содержат любую выдачу себя за других участников, общественных деятелей или знаменитостей
    - содержат каких-либо записей или личной информации о каком-либо человеке без согласия такого лица и не нарушают какие-либо правила защиты данных в любой части мира
    - содержат коммерческих предложений или «спама» в любой форме`
  },

  navigation: {
    account: 'Аккаунт',
    assessments: 'Оценивания',
    dashboard: 'Личный кабинет',
    groups: 'Управление группами',
    logout: 'Выйти',
    organisations: 'Организации',
    organizations_users: 'Организации и пользователи',
    reports: 'Отчеты',
    schedule: 'Расписание',
    training: 'Обучение',
    nowLive: 'трансляция',
    users: 'Пользователи',
    workshop: 'Мой воркшоп'
  },

  onboarding: {
    step1_title: 'Шаг 1: Расскажите нам немного о себе',
    step1_subtitle: 'Как вас зовут? Откуда вы? Какая у вас должность?',
    step2_title: 'Шаг 2: Выберите навык, который вы могли бы улучшить',
    step2_subtitle:
      'Затем расскажите нам, что вы хотели бы лучше понять. Возможно, вам еще предстоит кое-что изучить? Новое направление обучения? Какое ваше любимое направление?'
  },

  pagebuilder: {
    title: 'Создать занятие',
    subtitle:
      'Самое время создать контент, которому бы могла научиться ваша аудитория, вы можете добавлять картинки, видео и инфографику',
    select_layout: 'Выберите макет страницы',
    template1: 'Пустой',
    template2: 'Заголовок и подзаголовок',
    template3: 'Заголовок и текст',
    template4: 'Заголовок, медиа и текст',
    template5: 'Заголовок и медиа',
    template6: 'Заголовок и викторина'
  },

  pageconstructor: {
    title: 'Создать и клонировать занятие',
    subtitle:
      'Самое время создать контент, которому бы могла научиться ваша аудитория, вы можете добавлять картинки, видео и инфографику'
  },

  passwordreset: {
    success_coded:
      'Мы отправили код подтверждения по электронной почте на указанный вами адрес. Скопируйте код в поле ниже, чтобы установить новый пароль.',
    success_changed:
      'Вы успешно установили новый пароль. Теперь вы можете войти в систему.'
  },

  placeholders: {
    search: 'Поиск',
    answer: 'Ответ',
    chat: 'Скажите что-нибудь...',
    code: 'Код',
    criterion: 'Критерий',
    date_event: 'Выберите дату и время',
    date_start: 'Дата начала',
    date_expire: 'Дата окончания',
    description: 'Описание',
    elements: 'Сортировать элементы',
    email: 'Адрес электронной почты',
    feedback_correct: 'Правильный отзыв',
    feedback_incorrect: 'Неправильный отзыв',
    host: 'Организатор',
    keywords: 'Поиск ключевого(ых) слов(а)',
    lesson_description: 'Описание занятия',
    location: 'Местонахождение',
    minutes: 'Минут',
    name: 'Название',
    organiser: 'Автор',
    organization: 'Организация',
    password: 'Пароль',
    phone: 'Телефон',
    photo: 'Фото',
    picture: 'Картинка',
    point: 'Балл',
    position: 'Должность',
    question: 'Вопрос',
    quiz: 'Название викторины',
    search_course: 'Поиск по курсу',
    search_media: 'Поиск медиа',
    search_name: 'Поиск по имени',
    search_title: 'Поиск по названию',
    search_training: 'Поиск обучения',
    settings: 'Настройки',
    tags: 'Теги',
    title: 'Заголовок',
    topics: 'Темы',
    username: 'Имя пользователя',
    keyword: 'Ключевые слова',
    max_500_characters: 'Максимум 500 символов',
    no_description: 'У этого файла нет описания',
    no_keyword: 'У этого файла нет ключевых слов',
    no_topics: 'У этого файла нет набора тем',
    feedback: 'Сообщение',
    contact: 'Как мы можем помочь?'
  },

  publishsettings: {
    title: 'Опубликовать настройки',
    event_subtitle:
      'Добавьте настройки для вашего мероприятия относительно того, кто может просматривать и взаимодействовать с вашим мероприятием',
    assessment_subtitile:
      'Дайте название своему оцениванию и расскажите аудитории, получение каких знаний они могут ожидать от него.',
    course_subtitle:
      'Добавьте настройки для вашего курса относительно того, кто может просматривать и взаимодействовать с вашим курсом',
    disclaimer: `1.	Регистрация

  Регистрируясь в качестве пользователя/создавая аккаунт, вы соглашаетесь с нашим [Пользовательским соглашением] и подтверждаете прочтение нашей [Политики конфиденциальности]

  2.	Создание курса

  Используя наши инструменты и создавая контент курса, вы соглашаетесь с нашим [Пользовательским соглашением] и подтверждаете прочтение нашей [Политики конфиденциальности]

  3.	Создание мероприятия

  Используя наши инструменты и создавая мероприятие, вы соглашаетесь с нашим [Пользовательским соглашением] и подтверждаете прочтение нашей [Политики конфиденциальности]

  4.	Создание оценивания

  Используя наши инструменты и создавая оценивание, вы соглашаетесь с нашим [Пользовательским соглашением] и подтверждаете прочтение нашей [Политики конфиденциальности]`,
    dates_validation_error: 'Обе даты должны быть заполнены.',
    emails_validation_error: 'Список рассылки недействителен.',
    specific_email_validation_error:
      'Разрешен только один адрес электронной почты.',
    i_agree_to_these: 'Я соглашаюсь с этими',
    terms_and_conditions: 'условиями и положениями.',
    PublicDescription:
      'Бесплатные независимые пользователи: (публичная и приватная опции) Ваш [курс|мероприятие|оценивание] был сохранен и по умолчанию считается приватным. Это означает, что данный контент можете видеть только вы. Чтобы опубликовать этот контент, вы можете сделать его публичным ниже. This means that the course will be available to all users in the platform.',
    OrganisationsDescription:
      'Организационные пользователи: (Вместо ""Завершить"" используйте ""Опубликовать"" и выведите их на страницу публикации так же, как и другие пользователи, но без каких-либо опций публикации.) Ваш [курс|мероприятие|оценивание] был сохранен и является приватным. Это означает, что данный контент можете видеть только вы и администраторы вашей организации. Как пользователь, вы не можете самостоятельно публиковать свой контент в своей организации, поскольку для этого требуются права администратора. Пожалуйста, свяжитесь с одним из своих администраторов и попросите их опубликовать ваш контент публично, для всей организации, для определенных групп внутри вашей организации или для определенных пользователей.',
    OrganisationGroupsDescription:
      'Организационные администраторы: (Для контента, созданного в рамках организации: приватно, публично, для организации, групп, определенных пользователей): Этот [курс|мероприятие|оценивание] был сохранен и по умолчанию считается приватным. Это означает, что данный контент можете видеть только вы (и создатель контента). Чтобы опубликовать этот контент, вы можете выбрать один из вариантов ниже. Публичная публикация курса означает, что он будет доступен для всех пользователей платформы, включая пользователей вне вашей организации. Публикация его для организации означает, что его смогут увидеть все пользователи организации. Вы также можете опубликовать его для одной или нескольких групп, то есть увидеть его смогут только пользователи этих групп. Наконец, у вас есть возможность опубликовать его для определенных пользователей внутри и за пределами вашей организации, используя адрес электронной почты их аккаунта Sharelook.',
    SpecificUsersDescription:
      'Платные независимые пользователи: (приватно, публично и для определенных пользователей) Ваш [курс|мероприятие|оценивание] был сохранен и по умолчанию считается приватным. Это означает, что данный контент можете видеть только вы. Чтобы опубликовать этот контент, вы можете выбрать один из вариантов ниже. Публичная публикация курса означает, что он будет доступен всем пользователям платформы. Параметр «Определенные пользователи» позволит вам поделиться своим курсом с определенными пользователями, используя адрес электронной почты, связанный с их аккаунтом Sharelook.'
  },

  quiz: {
    quiz_empty: 'Вы еще не создали викторину',
    questions_empty: 'Вы еще не создали вопрос'
  },

  regions: {
    asia_pacific_australia: 'Австралия',
    asia_pacific_india: 'Индия',
    asia_pacific_japan: 'Япония',
    asia_pacific_s_korea: 'Южная Корея',
    asia_pacific_singapore: 'Сингапур',
    asia_pacific_taiwan: 'Тайвань',
    eu_belgium: 'Бельгия',
    eu_germany: 'Германия',
    eu_ireland: 'Ирландия',
    south_america_brazil: 'Бразилия',
    us_central_iowa: 'Айова',
    us_east_s_carolina: 'Южная Каролина',
    us_east_virginia: 'Вирджиния',
    us_west_california: 'Калифорния',
    us_west_oregon: 'Орегон'
  },

  reports: {
    title: 'Отчеты'
  },

  signup: {
    success_step1:
      'Мы отправили код подтверждения по электронной почте на указанный вами адрес. Пожалуйста, скопируйте код в поле ниже, чтобы подтвердить вашу регистрацию.',
    success_step2: 'Спасибо. Вы успешно зарегистрированы.',
    privacy: `Я соглашаюсь с <1>условиями и положениями</1>, а также с <3>политикой конфиденциальности</3> Sharelook`
  },

  stream: {
    emotion_impressive: 'Впечатляюще',
    emotion_unimpressive: 'Невпечатляюще',
    message_not_started: 'Скоро',
    message_running: 'Прямая трансляция',
    message_processing:
      'В настоящее время мы обрабатываем живую запись для воспроизведения. Повторите попытку позже, чтобы просмотреть видео и продолжить добавление оценок и отзывов'
  },

  tabs: {
    audience: 'Аудитория',
    course: 'Обзор курса',
    details: 'Детали прямой трансляции',
    description: 'Описание',
    host: 'Организатор',
    lesson: 'Обзор занятия',
    lessons: 'Занятия',
    overview: 'Обзор',
    page: 'Конструктор страниц',
    publish: 'Опубликовать',
    settings: 'Опубликовать настройки',
    total_views: 'Всего просмотров',
    live_participates: 'Участники в режиме реального времени',
    live_chats: 'Чаты в режиме реального времени',
    live_quiz: 'Опросы в режиме реального времени',
    trainer_rating: 'Рейтинг инструктора',
    trainer_times: 'Время инструктора',
    courses_quizzes: 'Викторины курсов',
    user_list: 'Список пользователей',
    discussion: 'Обсуждение',
    notes: 'Мои заметки'
  },

  topics: {
    SALES_TRAINING: 'Обучение продажам',
    NEGOTIATION_TRAINING: 'Обучение переговорам',
    CROSS_CULTURAL_AWARENESS: 'Межкультурная осведомленность',
    NETWORKING_SKILLS: 'Навыки установления контактов',
    SOFTWARE_ARCHITECTURE: 'Архитектура программного обеспечения',
    PROJECT_MANAGEMENT: 'Управление проектами',
    DIGITAL_TRANSFORMATION: 'Цифровая трансформация',
    IT_CONSULTING: 'ИТ-консалтинг',
    MANAGEMENT_CONSULTING: 'Управленческий консалтинг',
    HR_CONSULTING: 'Кадровый консалтинг',
    INTERNET_OF_THINGS: 'Интернет вещей (IoT)',
    CYBERSECURITY: 'Кибербезопасность',
    PRIVACY_AND_GDRP: 'Конфиденциальность и GDPR'
  },

  training: {
    title: 'Обучение',
    title_assessment: 'Оценивания',
    subtitle: 'Курсы и мероприятия',
    enrolled_title: 'Запись на курсы и мероприятия',
    enrolled_subtitle: 'Курсы и мероприятия, на которые вы записались',
    enrolled_message:
      'В настоящее время вы не записаны ни на один курс или мероприятие.',
    past_live_event_title: 'Прошедшие прямые трансляции',
    past_live_event_subTitle: 'Завершенные прямые трансляции',
    past_live_event:
      'В настоящее время прошедшие прямые трансляции отсутствуют.',
    recomended_title: 'Рекомендуемые курсы и трансляции',
    now_live_event_title: 'Транслируются сейчас',
    now_live_event_subTitle:
      'Мероприятия, которые транслируются сейчас или уже скоро будут транслироваться',
    now_live_event:
      'В настоящее время нет трансляций в режиме реального времени.',
    webinar_event_title: 'Канал вебинара',
    webinar_event_subTitle: 'Завершенные вебинары',
    webinar_event: 'В настоящее время вебинары отсутствуют.',
    p2p_event_title: 'Сессии коучинга',
    p2p_event_subTitle: 'Завершенная сессия коучинга',
    p2p_event: 'В настоящее время сессии коучинга отсутствуют.',

    now_live_assessment_title: 'Транслируются сейчас',
    now_live_assessment_subTitle:
      'Оценивания, которые транслируются сейчас или уже скоро будут транслироваться',
    now_live_assessment_message:
      'В настоящее время оценивания в режиме реального времени отсутствуют.',

    upcoming_assessment_title:
      'Предстоящие оценивания в режиме реального времени',
    upcoming_assessment_subtitle:
      'Предстоящие оценивания в режиме реального времени',
    upcoming_assessment_message:
      'В настоящее время нет предстоящих оцениваний в режиме реального времени.',

    past_live_assessment_title:
      'Прошедшие оценивания в режиме реального времени',
    past_live_assessment_subTitle:
      'Завершенные оценивания в режиме реального времени',
    past_live_assessment_message:
      'В настоящее время прошедшие оценивания в режиме реального времени отсутствуют.',

    /**
     * <0/> get index 0 of data from Trans component
     * exp -->
     * <Trans i18nKey='training:recomended_subtitle' >
     *    <Navlink>{...something}</Navlink> --> is index 0 of Trans component
     *    <h1>{...something}</h1> --> is index 1 of Trans component
     * </Trans>
     */
    recomended_subtitle: `Мы организовали курсы и мероприятия в прямом эфире на основе вашего <0><0/></0>`,
    /**
     * and we also can get data from index to replace in recommended_subtitle by like above string.
     * for exp -->
     * at the end of the recomended_subtitle above will get data from index of component to display
     * <0><0/></0> mean get data index 0 of Trans component above = <Navlink> and <0/> get data index 0 from <Navlink> = {...something}
     */
    search: 'Поиск обучения',
    search_assessment: 'Поиск оценивания',
    recomended_message:
      'В настоящий момент рекомендуемые курсы и мероприятия отсутствуют.'
  },

  warnings: {
    delete: 'Вы уверены?'
  },

  workshop: {
    title: 'Мой воркшоп',
    subtitle:
      'Создайте собственный курс или проведите собственное мероприятие в прямом эфире',
    new_course: 'Создать новый курс',
    new_event:
      'Создать новое мероприятие с трансляцией в режиме реального времени',
    new_assessment: 'Создать новое оценивание в режиме реального времени',
    courses_title:
      'Созданные курсы и мероприятия с трансляцией в режиме реального времени',
    courses_subtitle:
      'Редактируйте и публикуйте созданный вами курс и планируйте мероприятия с трансляцией в режиме реального времени',
    tags_course: 'Курс',
    tags_live: 'Мероприятие с трансляцией в режиме реального времени',
    tags_assessment: 'Оценивание в режиме реального времени'
  },

  help_center: {
    sidebar: {
      title: 'Как мы можем вам помочь?',
      back_to: 'Личный кабинет'
    },
    menu: {
      help_center: 'Центр помощи',
      whats_new: 'Что нового',
      feedback: 'Обратная связь',
      feedback_title: 'Отправьте отзыв sharelook',
      terms_and_conditions: 'Условия и положения',
      privacy_policy: 'Политика конфиденциальности',
      contact_us: 'Связь с нами'
    },
    get_started: {
      title: 'Начните с share look',
      description: {
        main:
          'МЫ ИНТЕГРИРОВАЛИ ЖИВОЕ ВИДЕО В ПРОСТОЙ В ИСПОЛЬЗОВАНИИ КОНСТРУКТОР КУРСОВ',
        tagline:
          'С запатентованной системой прямой трансляции ShareLook вы можете привлечь внимание, автоматизировать обучение и максимально расширить обмен знаниями.'
      }
    },
    whats_new: {
      title: 'Начните с share look',
      description: {
        main:
          'А вы знали, что создание стиля обучения на примерах можно создать за короткое время и не так дорого? Вам следует объединить конструктор курсов ShareLook и соответствующие таланты. Вы можете спросить у нас "КАК',
        tagline: ''
      }
    },
    create_workshop: 'Как создать воркшоп',
    create_course: 'Как создать курс',
    create_user: 'Как создать пользователя',
    create_group: 'Как создать группу',
    create_webinar: 'Как создать вебинар',
    create_live_event: 'Как создать мероприятие с трансляцией',
    create_live_assessment: 'Как создать оценивание в режиме реального времени',
    create_live_on_mobile: 'Создать трансляцию с мобильного телефона',
    personalize_profile: 'Персонализировать профиль',
    manage_group: 'Управлять группой',
    report: 'Отчет',
    add_annotations: 'Как добавить аннотации/всплывающие окна',
    add_audio: 'Как добавить аудио',
    add_header_and_footer: 'Добавление хедера и футера',
    add_image: 'Как добавить изображение',
    add_quiz_content: 'Как добавить викторину',
    add_text_content: 'Как добавить текстовый контент',
    add_user: 'Как добавить пользователя',
    add_video: 'Как добавить видео',
    clone_course: 'Как клонировать курс',
    find_live_broadcast: 'Как найти прямую трансляцию ',
    contact_us: {
      title: 'Свяжитесь с нами',
      subject_placeholder: 'Введите тему*',
      content_placeholder: 'Введите сообщение*',
      subject_required: '*Тема является обязательной',
      content_required: '*Сообщение является обязательным',
      submit: 'Отправить',
      cancel: 'Отмена',
      sent: 'Отправлено'
    },
    feedback: {
      title: 'Отправьте отзыв sharelook',
      attach_title: 'Прикрепить файл',
      choose: 'Выбрать файл',
      detail: 'Файл будет передан в службу поддержки',
      content_placeholder: 'Ввести сообщение*',
      content_required: '*Сообщение является обязательным',
      submit: 'Отправить',
      cancel: 'Отмена',
      sent: 'Отправлено'
    }
  },
  discussion: {
    join_discussion: 'Присоединиться к обсуждению'
  },
  notes: {
    title: 'Мои заметки',
    add_note: 'Добавить новую заметку'
  }
}
